/** Russian translations */
export default {
  'paidScript.title': 'Платный сеанс по скрипту',
  'paidScript.allowScript': 'Разрешить этот скрипт для платного сеанса',
  'paidScript.scriptHint': 'Одна общая оплата, затем медиа по этапам без новых PPV. Обычная продажа отдельных этапов не отключается.',
  'paidScript.price': 'Общая цена скрипта, USD',
  'paidScript.terms': 'Цена и состав фиксируются при оформлении предложения. Новые настройки не меняют уже согласованные пакеты. Это не безлимитный чат или обещание продолжительности.',
  'paidScript.modelEnabled': 'Включить режим для модели',
  'paidScript.modelHint': 'По умолчанию выключен. После включения разрешите нужные скрипты и задайте общую цену. Сам переключатель не отправляет сообщения и не снимает manual.',
  'paidScript.configScope': 'Основной конфиг: {name}. Индивидуальные конфиги чатов не меняются.',
  'paidScript.sharedConfig': 'Нужен отдельный основной конфиг модели; общий конфиг нескольких моделей здесь менять нельзя.',
  'paidScript.disableConfirm': 'Остановить режим? Существующие пакеты и права сохранятся, но доставка будет приостановлена без перехода к повторным PPV.',
  'paidScript.loadError': 'Не удалось загрузить настройки платных сеансов',
  'paidScript.saveError': 'Не удалось сохранить настройки платных сеансов',
  'paidScript.loading': 'Загрузка настроек…',
  'paidScript.noScripts': 'Нет разрешённых скриптов. В разделе «Контент» включите платный сеанс у скрипта и задайте цену.',
  'app.name': 'FanLTV',
  'safetyReview.noticeTitle': 'Автоматические ответы заблокированы системой безопасности',
  'safetyReview.noticeExplanation': 'Блокировка снимается только после подтверждения проверки диалога. Само по себе включение VIP не разблокирует чат.',
  'safetyReview.active': 'Safety-lock остаётся активным. {target}',
  'safetyReview.reason': 'Причина: {reason}',
  'safetyReview.since': 'Блокировка установлена: {time}',
  'safetyReview.reasonUnknown': 'Причина недоступна — сначала проверьте диалог',
  'safetyReview.unknown': 'Неизвестно',
  'safetyReview.stateConflict': 'Состояние диалога изменилось, но safety-lock не был снят.',
  'safetyReview.checkFirst': 'Продолжайте только после проверки диалога и подтверждения, что автоматизация безопасна.',
  'safetyReview.confirmResume': 'Включение авто снимет имеющийся safety-lock и разрешит автоматические ответы. Подтверждаю, что проверил диалог — продолжить?',
  'safetyReview.confirmUnlock': 'Подтверждаю, что проверил эту блокировку. Снять её? Ручной режим не будет выключен.',

  // Layout / navigation
  'layout.theme.light': 'Светлая тема',
  'layout.theme.dark': 'Тёмная тема',
  'layout.logout': 'Выйти',
  'layout.nav.models': 'Модели',
  'layout.nav.fyp': 'FYP публикации',
  'layout.nav.fans': 'Фаны',
  'layout.nav.chats': 'Чаты',
  'layout.nav.analytics': 'Аналитика',
  'layout.nav.purchases': 'Покупки',
  'layout.nav.logs': 'Логи',
  'layout.nav.settings': 'Настройки бота',
  'layout.nav.configuration': 'Конфигурации',
  'layout.language': 'Язык',
  'layout.language.ru': 'Русский',
  'layout.language.en': 'English',
  'layout.language.ruShort': 'RU',
  'layout.language.enShort': 'EN',

  // Autotests
  'autotests.nav.title': 'Автотесты',
  'autotests.nav.dashboard': 'Тесты',
  'autotests.nav.scenarios': 'Сценарии',
  'autotests.nav.analysis': 'Анализ логов',
  'autotests.runAll': 'Запустить все автотесты',
  'autotests.run': 'Запустить',
  'autotests.status.PASSED': 'Пройден',
  'autotests.status.FAILED': 'Провален',
  'autotests.status.RUNNING': 'Выполняется',
  'autotests.status.ERROR': 'Ошибка',
  'autotests.scenarios.create': 'Создать сценарий',
  'autotests.rounds.title': 'Раунды',
  'autotests.conversation': 'Диалог',
  'autotests.analysis.quickScan': 'Quick Scan',
  'autotests.analysis.daily': 'Daily Report',
  'autotests.analysis.weekly': 'Weekly Report',
  'autotests.analysis.buildReport': 'Построить отчёт',
  'autotests.noAccess.title': 'Нет доступа',
  'autotests.noAccess.message': 'У вас нет прав для раздела автотестов.',
  'autotests.noAccess.back': 'Назад',
  'autotests.dashboard.subtitle': 'Сводка по запускам автотестов и алертам',
  'autotests.dashboard.summary': 'Сводка',
  'autotests.dashboard.latestReport': 'Последний analysis report',
  'autotests.dashboard.latestRuns': 'Последние запуски',
  'autotests.filters.status': 'Статус',
  'autotests.filters.all': 'Все',
  'autotests.filters.active': 'Активные',
  'autotests.filters.inactive': 'Неактивные',
  'autotests.validation.modelFanRequired': 'model_id и fan_id обязательны и должны быть положительными числами',
  'autotests.validation.maxRounds': 'max_rounds должен быть integer >= 1',
  'autotests.validation.timeout': 'round_timeout_seconds должен быть integer >= 10',
  'autotests.validation.scenarioId': 'scenario_id должен соответствовать шаблону [a-z0-9_\\-]{3,100}',
  'autotests.validation.nameRequired': 'name обязателен',
  'autotests.validation.configJson': 'config должен быть валидным JSON',
  'autotests.validation.modelRequired': 'Укажите корректный model_id',
  'autotests.validation.fanRequired': 'Укажите корректный fan_id',
  'autotests.validation.hours': 'hours должен быть integer в диапазоне 1..168',
  'autotests.toast.started': 'Тест запущен. Проверьте результаты на Dashboard',
  'autotests.toast.taskStarted': 'Тест запущен (задача {task_id}). Проверьте результаты на Dashboard',
  'autotests.scenarioCreated': 'Сценарий создан',
  'autotests.scenarios.subtitle': 'Список и запуск тестовых сценариев',
  'autotests.scenarios.steps': 'Количество шагов',
  'autotests.scenarios.viewConfig': 'Просмотр конфига',
  'autotests.scenarios.configHintTitle': 'Подсказка по config JSON',
  'autotests.scenarios.configHintRuleId': 'Используйте стабильный scenario_id (латиница, цифры, _, -).',
  'autotests.scenarios.configHintRuleSteps': 'Шаги сценария добавляйте в массив steps.',
  'autotests.scenarios.configHintRuleExpected': 'В expected указывайте ожидаемый state и goal после шага.',
  'autotests.scenarios.useMinimalTemplate': 'Вставить минимальный шаблон',
  'autotests.scenarios.generateSimpleConfig': 'Сгенерировать простой config',
  'autotests.status': 'Статус',
  'autotests.date': 'Дата',
  'autotests.scenario': 'Сценарий',
  'autotests.passedFailed': 'passed / failed',
  'autotests.runDetail.subtitle': 'Детали запуска',
  'autotests.backToDashboard': 'К dashboard',
  'autotests.rounds.total': 'Всего раундов',
  'autotests.rounds.noBotResponse': 'Ответ отсутствует',
  'autotests.analysis.subtitle': 'Запуск задач анализа и просмотр отчётов',
  'autotests.analysis.tasks': 'Быстрые задачи',
  'autotests.analysis.modelTask': 'Запуск по модели',
  'autotests.analysis.reports': 'Отчёты',
  'autotests.expand': 'Показать больше',
  'autotests.collapse': 'Свернуть',
  'autotests.empty': 'Данных пока нет',
  'autotests.form.modelId': 'Модель',
  'autotests.form.fanId': 'Фан',
  'autotests.form.maxRounds': 'Максимум раундов',
  'autotests.form.roundTimeoutSeconds': 'Таймаут раунда (сек)',
  'autotests.form.activeOnly': 'Только активные сценарии',
  'autotests.form.scenarioId': 'ID сценария',
  'autotests.form.scenarioIdOptionalPlaceholder': 'опционально, если пусто — сгенерируется автоматически',
  'autotests.form.name': 'Название',
  'autotests.form.description': 'Описание',
  'autotests.form.configJson': 'Конфиг (JSON)',
  'autotests.form.round': 'Раунд',
  'autotests.form.fanBehavior': 'Поведение фана',
  'autotests.form.botStateAfter': 'Состояние после шага',
  'autotests.form.botGoal': 'Цель бота',
  'autotests.form.reportType': 'Тип отчёта',
  'autotests.form.hours': 'Часы (1..168)',
  'autotests.form.scopeType': 'Скоуп',
  'autotests.form.isTest': 'Только тестовые данные',
  'autotests.form.period': 'Период',
  'autotests.form.summary': 'Сводка',
  'autotests.form.anomalies': 'Аномалии',
  'autotests.form.recommendations': 'Рекомендации',
  'autotests.form.fanMessage': 'Сообщение фана',
  'autotests.form.botResponse': 'Ответ бота',
  'autotests.form.stateTransition': 'Состояние: до → после',
  'autotests.form.goalSelected': 'Выбранная цель',
  'autotests.form.qualityScores': 'Оценки качества',
  'autotests.form.assertions': 'Проверки',
  'autotests.form.durationMs': 'Длительность (мс)',
  'autotests.help.round': 'Порядковый номер шага диалога в сценарии (1, 2, 3...).',
  'autotests.help.fanBehavior': 'Что делает/пишет фан на этом шаге (например casual_greeting).',
  'autotests.help.botStateAfter': 'Ожидаемое состояние бота после обработки этого шага.',
  'autotests.help.botGoal': 'Ожидаемая цель бота после шага (например warm_up, offer).',

  // Login
  'login.title': 'FanLTV',
  'login.titleAdmin': 'Админ',
  'login.titleUser': 'Вход',
  'login.titleTester': 'Тестер',
  'login.username': 'Логин',
  'login.password': 'Пароль',
  'login.error': 'Ошибка входа',
  'login.submit': 'Войти',
  'login.submitting': 'Вход…',

  // Common
  'common.loading': 'Загрузка…',
  'common.add': 'Добавить',
  'common.cancel': 'Отмена',
  'common.save': 'Сохранить',
  'common.saving': 'Сохранение…',
  'common.delete': 'Удалить',
  'common.deleting': 'Удаление…',
  'common.error': 'Ошибка',
  'common.retry': 'Повторить',
  'common.notSelected': 'Не выбрано',
  'common.notAvailable': '—',
  'common.edit': 'Изменить',
  'common.actions': 'Действия',
  'common.loadMore': 'Показать ещё',
  'pagination.range': '{from}–{to} из {total}',
  'pagination.page': 'Страница {n}',
  'common.close': 'Закрыть',

  // Toast notifications
  'toast.media.movedToSession': 'Медиа перемещено в фотосессию',
  'toast.media.movedToSessionCount': '{count} медиа перемещено в фотосессию',
  'toast.media.unlinkedFromSession': 'Медиа отвязано от фотосессии',
  'toast.media.unlinkedFromSessionCount': '{count} медиа отвязано от фотосессии',
  'toast.media.moved': 'Медиа перемещено',
  'toast.media.movedCount': '{count} медиа перемещено',
  'toast.media.movedToUngrouped': 'Медиа перемещено в «Без группы»',
  'toast.media.movedToUngroupedCount': '{count} медиа перемещено в «Без группы»',
  'toast.media.saved': 'Медиа сохранено',
  'toast.session.createdWithMedia': 'Фотосессия создана, медиа перемещено',
  'toast.session.createdWithMediaCount': 'Фотосессия создана, {count} медиа перемещено',
  'toast.session.saved': 'Фотосессия сохранена',
  'toast.session.deleted': 'Фотосессия удалена',
  'toast.group.created': 'Группа создана',
  'toast.group.deleted': 'Группа удалена',
  'toast.groups.reordered': 'Порядок групп изменён',
  'toast.sessions.reordered': 'Порядок фотосессий изменён',
  'toast.order.changed': 'Порядок изменён',
  'toast.sync.started': 'Синхронизация запущена',
  'toast.sync.stopped': 'Синхронизация остановлена',
  'toast.model.created': 'Модель создана',
  'toast.model.deleted': 'Модель удалена',
  'toast.connection.started': 'Подключение запущено',
  'toast.connection.cancelled': 'Подключение отменено',
  'toast.provider.disconnected': 'Провайдер отключён',
  'toast.credentials.saved': 'Учётные данные сохранены',
  'toast.account.descriptionSaved': 'Описание аккаунта сохранено',
  'toast.user.created': 'Пользователь создан',
  'toast.user.updated': 'Пользователь обновлён',
  'toast.user.deleted': 'Пользователь удалён',
  'toast.user.modelAdded': 'Модель назначена',
  'toast.user.modelRemoved': 'Модель снята',
  'toast.error.moveFailed': 'Не удалось переместить',
  'toast.error.createSessionFailed': 'Не удалось создать сессию',
  'toast.error.reorderFailed': 'Не удалось изменить порядок',
  'toast.error.syncFailed': 'Ошибка синхронизации',
  'toast.error.stopSyncFailed': 'Не удалось остановить',
  'toast.settings.saved': 'Сохранено',
  'toast.settings.saveFailed': 'Не удалось сохранить',
  'toast.llm.grokFailed': 'Модели Grok недоступны: {error}',
  'toast.llm.openaiFailed': 'Модели OpenAI недоступны: {error}',
  'toast.llm.groqFailed': 'Модели Groq недоступны: {error}',
  'toast.llm.openrouterFailed': 'Модели OpenRouter недоступны: {error}',
  'toast.llm.minimaxFailed': 'Модели MiniMax недоступны: {error}',

  // Settings
  'settings.title': 'Конфигурации',
  'settings.nav.graph': 'Схема',
  'settings.nav.overview': 'Обзор',
  'settings.nav.configuration': 'Конфигурация',
  'settings.nav.agents': 'Агенты',
  'settings.nav.nodes': 'Узлы',
  'settings.nav.edges': 'Связи',
  'settings.nav.variables': 'Переменные',
  'settings.nav.proactive': 'Проактивный бот',
  'settings.nav.executor': 'Исполнитель / доставка',
  'settings.nav.other': 'Остальные настройки',
  'settings.nav.users': 'Пользователи',
  'settings.config.rename': 'Переименовать',
  'settings.config.renameModalTitle': 'Переименовать конфигурацию',
  'settings.config.renamed': 'Конфиг переименован',

  // Проактивный бот (check_followup_needed, каждые 10 мин)
  'settings.proactive.intro': 'Проактивный бот каждые 10 минут решает: кому написать первым (follow-up по молчанию). Для выбранных фанов вызывается агент proactive_message_generator — он генерирует сообщение по параметрам и переписке.',
  'settings.proactive.agentConfigLink': '→ Настроить агент proactive_message_generator (модель, промпты)',
  'settings.proactive.logicTitle': 'Как бот решает, кому написать',
  'settings.proactive.logicIntro': 'check_followup_needed каждые 10 мин проверяет фанов. Написать можно только если выполнены все условия:',
  'settings.proactive.logicState': 'Стейт (RAPPORT, FLIRT, PRESELL, OFFER, POSTBUY, COOLDOWN) → порог молчания в минутах. Чем «горячее» стейт — тем короче порог.',
  'settings.proactive.logicAttachment': 'emotional_attachment_score > 70 → порог умножается на множитель (0.5 = вдвое чаще).',
  'settings.proactive.logicRapportReturned': 'RAPPORT + фан уже писал раньше (messages_processed_count > 0) → порог rapport_returned, иначе rapport.',
  'settings.proactive.logicFilters': 'Доп. фильтры: не manual_mode, не SAFETY_LOCK, модель готова, send_restriction (если включён — только фаны из allow-list). Нет активного графа, debounce, delayed_send. last_message_at есть (фан хоть раз писал).',
  'settings.proactive.logicCooldown': 'После followup_sent_at — не писать снова, пока не пройдёт порог молчания (защита от спама).',
  'settings.proactive.rulesTitle': 'Правила follow-up',
  'settings.proactive.rulesIntro': 'Добавьте правила: условия (L4 переменные) + интервал молчания в минутах. Значение сохраняется с шагом 10 минут. Первое совпадение определяет порог.',
  'settings.proactive.ruleLabel': 'Правило {n}',
  'settings.proactive.hoursLabel': 'Часы',
  'settings.proactive.hoursUnit': 'ч',
  'settings.proactive.minutesUnit': 'мин',
  'settings.proactive.hoursCondition': 'Тишина ≥',
  'settings.proactive.conditionsLabel': 'И условия:',
  'settings.proactive.addRule': '+ Добавить правило',
  'settings.proactive.noRules': 'Правил нет. Добавь правило.',
  'settings.proactive.ruleNameLabel': 'Название правила',
  'settings.proactive.ruleNamePlaceholder': 'Выход онлайн, высокая привязанность, после покупки...',
  'settings.proactive.rulePromptLabel': 'Промпт для этого условия',
  'settings.proactive.rulePromptPlaceholder': 'Дополнительная инструкция только для этого правила. Например: упомяни, что увидела его онлайн, мягко продолжи диалог и задай один простой вопрос.',
  'settings.proactive.desc.bot_silence_followup_rapport_hours': 'Follow-up — бот сам пишет фану, если тот не отвечал N часов. Порог для RAPPORT (новый фан, ещё мало общались).',
  'settings.proactive.desc.bot_silence_followup_rapport_returned_hours': 'Follow-up — бот сам пишет фану после молчания. Порог для RAPPORT, когда фан вернулся после паузы (уже был диалог).',
  'settings.proactive.desc.bot_silence_followup_flirt_hours': 'Follow-up — бот сам пишет фану после молчания. Порог для стейта FLIRT (флирт, прогрев).',
  'settings.proactive.desc.bot_silence_followup_presell_hours': 'Follow-up — бот сам пишет фану после молчания. Порог для стейта PRESELL (продаём, но ещё не оффер).',
  'settings.proactive.desc.bot_silence_followup_offer_hours': 'Follow-up — бот сам пишет фану после молчания. Порог для стейта OFFER (активная продажа).',
  'settings.proactive.desc.bot_silence_followup_postbuy_hours': 'Follow-up — бот сам пишет фану после молчания. Порог для стейта POSTBUY (только что купил, aftercare).',
  'settings.proactive.desc.bot_silence_followup_cooldown_hours': 'Follow-up — бот сам пишет фану после молчания. Порог для стейта COOLDOWN (пауза после покупки/оффера).',
  // Users (admin)
  'users.hint': 'Создание пользователей, смена паролей и ролей. Для ролей пользователь и агентство — назначение моделей.',
  'users.add': 'Добавить пользователя',
  'users.username': 'Логин',
  'users.role': 'Роль',
  'users.role.admin': 'Админ',
  'users.role.agency': 'Агентство',
  'users.role.user': 'Пользователь',
  'users.role.tester': 'Тестер',
  'users.role.tester_no_media': 'Тестер без медиа',
  'users.role.tester_plus': 'Тестер плюс',
  'users.agency.optionsTitle': 'Доступ агентства',
  'users.agency.conditionalPromptsAccess': 'Разрешить редактирование условных промптов',
  'users.agency.conditionalPromptsHint': 'Создаёт копию конфига для агентства и показывает раздел условных промптов в настройках агентства.',
  'users.agency.chatDiagnosticsAccess': 'Разрешить просмотр воронки и логов чатов',
  'users.agency.chatDiagnosticsHint': 'Показывает стадии диалога, сигналы воронки и очищенные технические логи только по моделям этого агентства.',
  'users.agency.engineApiAccess': 'Включить FanLTV Engine API',
  'users.agency.engineApiHint': 'Разрешает агентству создавать ограниченные API-клиенты для внешних creator-, companion- и dating-платформ. Автоматическая отправка контролируется отдельно.',
  'users.agency.billingPlan': 'План оплаты',
  'users.agency.billingCurrency': 'Валюта',
  'users.agency.billingRate': 'Тариф за сообщение бота',
  'users.agency.balance': 'Баланс',
  'users.agency.topUp': 'Пополнить баланс',
  'users.agency.topUpHint': 'Сумма пополнения прибавится к сохранённому балансу после нажатия Save.',
  'users.agency.lowBalanceThreshold': 'Порог низкого баланса',
  'users.modelAccessTitle': 'Доступ к моделям',
  'users.modelAccessHint': 'Выбранные модели назначаются сразу после создания. Для агентства модели используют копию конфига агентства.',
  'users.isActive': 'Активен',
  'users.active': 'Да',
  'users.inactive': 'Нет',
  'users.password': 'Пароль',
  'users.passwordLeaveEmpty': 'оставьте пустым, чтобы не менять',
  'users.passwordPlaceholder': 'Новый пароль (если нужно изменить)',
  'users.passwordMin': 'Пароль не менее 6 символов',
  'users.createTitle': 'Новый пользователь',
  'users.editTitle': 'Редактировать пользователя',
  'users.models': 'Модели',
  'users.modelsTitle': 'Модели пользователя {username}',
  'users.modelsLinked': 'Назначенные модели',
  'users.modelsAdd': 'Добавить модель',
  'users.addModel': 'Добавить',
  'users.noModels': 'Нет назначенных моделей',
  'users.deleteConfirmTitle': 'Удалить пользователя?',
  'users.deleteConfirmMessage': 'Пользователь {username} будет удалён.',
  'users.createError': 'Не удалось создать пользователя',
  'users.updateError': 'Не удалось обновить пользователя',
  'users.deleteError': 'Не удалось удалить пользователя',
  'settings.tabs.graph': 'Граф',
  'settings.tabs.settings': 'Параметры',
  'settings.tabs.agents': 'Агенты',
  'settings.tabs.prompts': 'Промпты',
  'settings.section.graph': 'Визуализация пайплайна',
  'settings.section.settings': 'Параметры графа (pipeline, silence, transitions)',
  'settings.section.agents': 'Конфигурация агентов',
  'settings.section.prompts': 'Промпты с переменными {{var}}',
  'settings.edgesHint': 'Условие перехода из Ядра на ветку продажи. Выполняется — идём Media Selector → offer_generator; не выполняется — идём message_generator. Формат: параметр, оператор, значение, И/ИЛИ.',
  'settings.variablesHint': 'L4 переменные для условий (transitions, conditional_prompts). Используются только L4.',
  'settings.variables.definitions': 'Определения переменных',
  'settings.variables.definitionsDesc': '',
  'settings.variables.empty': 'Пусто. Используются params + L2 (обратная совместимость).',
  'settings.variables.key': 'Ключ',
  'settings.variables.type': 'Тип',
  'settings.variables.range': 'Диапазон',
  'settings.variables.purpose': 'Назначение',
  'settings.variables.source': 'Источник',
  'settings.variables.levelL1': 'L1',
  'settings.variables.levelL2': 'L2',
  'settings.variables.levelL3': 'L3',
  'settings.variables.levelL4': 'L4',
  'settings.variables.l1Title': 'L1 — выход анализатора',
  'settings.variables.l1Desc': 'Read-only. Выход message_analyzer (intent, tone, scores).',
  'settings.variables.l2Title': 'L2 — переменные из БД',
  'settings.variables.l2Desc': 'Read-only. Считаются при каждом запуске графа.',
  'settings.variables.l3Title': 'L3 — параметры Ядра',
  'settings.variables.l3DescHardcoded': 'Read-only. Захардкоженные 9 параметров (0–100). Расчёт: prev + observed_delta из L1, clamp 0–100. Доступны в L4 как source_type: l3.',
  'settings.variables.l3.howItWorks': 'Как это работает',
  'settings.variables.l3.howItWorksContent': `1. Прямые дельты (сигнал → параметр +N / −N)
Большинство параметров: от L1 приходит сигнал (compliment_detected, intent, emotion и т.д.), Core прибавляет или вычитает число. Дельты ограничены ±15 за шаг (max_delta). Настраиваются в «Остальное» (signal_delta_*).

2. Blend — content_readiness_score
Не просто сумма дельт. raw_llm = значение после дельт от сигналов. computed = engagement×0.2 + sexual_tension×0.35 + intimacy×0.3 − resistance×0.15. Итог: blended = raw_llm×0.4 + computed×0.6 (40% сырое + 60% формула). Не даёт параметру улететь в крайности.

3. Условные решения — allow_offer, risk_flag
allow_offer: захардкожен (см. блок ниже). risk_flag = true → SAFETY_LOCK.

4. Constraints для Message Generator
Из параметров считаются: intimacy_level, pressure, tone, length, explicit_level, allow_offer. Передаются в Message Generator.

5. Счётчики и фазы
messages_since_offer, ignored_question_counter, failed_offer_counter, postbuy_phase — в profile.parameters. postbuy_phase: delivery → aftercare. Переходы — условиями в Связях.`,
  'settings.variables.l3.calc.engagement_score': 'Формула: new = prev + delta, результат 0–100. Delta за сообщение ограничена ±max_delta.\n\nВклады в delta (суммируются, затем clamp ±max_delta):\n  trust_score (0–100) анализатора → round((score−50)×scale), напр. 65→+3, 40→−2\n  intent: greeting, small_talk → +2\n  intent: compliment, answered_questions → +3 или +4\n  intent: reengagement → +5\n  emotion: excited → +4\n  emotion: playful → +2\n  emotion: cold → −3\n  compliment_detected → +3\n  ignored_question → −3\n  ignored_question_counter ≥ 3 (L2) → −2',
  'settings.variables.l3.calc.emotional_attachment_score': 'Формула: new = prev + delta, 0–100. Delta ±max_delta за сообщение.\n\nВклады:\n  attachment_score анализатора → round((score−50)×scale)\n  intent: compliment, reengagement → +4..+5\n  emotion: affectionate, warm, needy, jealous → +2..+4\n  compliment_detected → +5\n  topic_shift_personal → +4\n  emotion: cold → −2\n  attachment_signal (0–5) → ×2',
  'settings.variables.l3.calc.sexual_tension_score': 'Формула: new = prev + delta, 0–100. Delta ±max_delta за сообщение.\n\nВклады:\n  sexual_tension_score, user_arousal_score анализатора → round((score−50)×scale)\n  intent: flirt → +4\n  intent: sexual_escalation → +6\n  emotion: horny, playful → +3..+5\n  asked_content, flirt_positive_response → +3..+5\n  sexual_intent_level (0–5) → ×1.2',
  'settings.variables.l3.calc.spending_intent_score': 'Формула: new = prev + delta, 0–100. Delta ±max_delta за сообщение.\n\nВклады:\n  spending_score анализатора → round((score−50)×scale)\n  intent: request_content, buy_intent → +4..+6\n  intent: price_check → +3\n  asked_content → +4\n  objection_or_resistance → −3\n  topic_shift_price → +3\n  payment_signal (0–5) → ×2\n  failed_offer_counter ≥ 2 (L2) → −2',
  'settings.variables.l3.calc.resistance_level': 'Формула: new = prev + delta, 0–100. Delta ±max_delta за сообщение.\n\nВклады:\n  resistance_score анализатора → round((score−50)×scale)\n  intent: angry, complaint → +6..+8\n  emotion: frustrated, defensive → +4\n  objection_or_resistance → +6\n  ignored_question → +2\n  ignored_question_counter ≥ 3 (L2) → +2\n  failed_offer_counter ≥ 2 (L2) → +3',
  'settings.variables.l3.calc.price_sensitivity': 'Дефолт 50. Прямых дельт из сигналов нет. Настраивается через graph_settings (signal_delta_*).',
  'settings.variables.l3.calc.risk_of_churn': 'Формула: new = prev + delta, 0–100. Delta ±max_delta за сообщение.\n\nВклады:\n  intent: reengagement → −5\n  intent: jealous, angry, inactive, complaint → +2..+5\n  emotion: frustrated, jealous → +2\n  objection_or_resistance → +3',
  'settings.variables.l3.calc.content_readiness_score': 'Формула: blend(raw_llm, computed), 0–100.\n\nДельты от L1 (как у других params): user_arousal_score, intent sexual_escalation/request_content/buy_intent, asked_content, emotion_horny, buy_intent_signal, sexual_intent_level.\n\nBlend после дельт:\n  raw_llm → значение после L1\n  computed → engagement×0.2 + sexual_tension×0.35 + intimacy×0.3 − resistance×0.15\n  итог → raw_llm×0.4 + computed×0.6, clamp 0–100',
  'settings.variables.l3.calc.intimacy_score': 'Формула: new = prev + delta, 0–100. Delta ±max_delta за сообщение.\n\nВклады:\n  intent: flirt → +3\n  emotion: affectionate, warm → +2..+3\n  compliment_detected, flirt_positive_response → +4\n  topic_shift_personal → косвенно\n  attachment_signal (0–5) → ×1.5',
  'settings.variables.l3.subTabParams': 'Параметры',
  'settings.variables.l3.derivedSection': 'Производные значения Core',
  'settings.variables.l3.derivedDesc': 'allow_offer, risk_flag. Условия перехода к офферу — в «Связи».',
  'settings.variables.l3.derived.allow_offer': 'allow_offer',
  'settings.variables.l3.derived.allow_offer.calc': 'Итог allow_offer в ядре: сначала postbuy_block (если в Core задан и истинен — allow_offer = false), затем run_monetization из вкладки «Связи». В превью одного условия смотрите блок «Итог монетизации ядра» после «Вычислить». В условиях можно использовать messages_since_offer, postbuy_phase и др.',
  'settings.variables.l3.derived.risk_flag': 'risk_flag',
  'settings.variables.l3.derived.risk_flag.calc': 'Производный bool: policy_risk_score ≥ policy_risk_safety_lock_threshold (порог в настройках Ядра) → risk_flag; risk_flag = true → SAFETY_LOCK, граф завершается без ответа.',
  'settings.variables.l3.derived.constraints': 'Constraints',
  'settings.variables.l3.derived.constraints.calc': 'allow_offer — для Monetization и Media. tone_style, explicit_level — для Description Generator и Policy Safety. В Message Generator не передаются — кастомизация через L4.',
  'settings.variables.l3.derived.counters': 'Счётчики (profile.parameters)',
  'settings.variables.l3.derived.counters.calc': 'compliment_counter, ignored_question_counter, messages_since_offer, failed_offer_counter, reengagement_counter, flirt_response_counter.\n  Обновляются из сигналов L1: compliment_detected, ignored_question, flirt_positive_response, reengagement. last_offer_failed → +1 failed_offer_counter.\n  messages_since_offer: +1 если allow_offer=false, else 0. Используются в дельтах (ignored_question_counter≥3 → engagement−2, resistance+2; failed_offer_counter≥2 → resistance+3, spending−2). Количество покупок — в L2 (purchase_count).',
  'settings.variables.l3.derived.postbuy_phase': 'postbuy_phase',
  'settings.variables.l3.derived.postbuy_phase.calc': 'После покупки: delivery → aftercare. Переход в COOLDOWN — условиями в Связях.',
  'settings.variables.l3Empty': 'Пусто. L3 доступны в L4 как source_type: l3.',
  'settings.variables.sourceParam': 'param',
  'settings.variables.sourceL2': 'l2',
  'settings.variables.sourceL3': 'l3',
  'settings.variables.sourceKey': 'Ключ источника',
  'settings.variables.typeInt': 'int',
  'settings.variables.typeFloat': 'float',
  'settings.variables.typeBool': 'bool',
  'settings.variables.typeEnum': 'enum',
  'settings.variables.keyPlaceholder': 'имя_переменной',
  'settings.variables.namePlaceholder': 'Название (в условиях)',
  'settings.variables.enumValuePlaceholder': 'значение',
  'settings.variables.addEnumValue': 'Добавить значение',
  'settings.variables.addBlock': 'Добавить переменную',
  'settings.variables.deleteVariableTitle': 'Удалить переменную?',
  'settings.variables.deleteVariableMessage': 'Переменная «{key}» будет удалена.',
  'settings.variables.deleteConditionTitle': 'Удалить условие?',
  'settings.variables.deleteConditionMessage': 'Условие (значение «{value}») будет удалено.',
  'settings.variables.add': 'Добавить',
  'settings.variables.addVariable': 'Добавить переменную',
  'settings.variables.editVariable': 'Редактировать переменную',
  'settings.variables.conditions': 'условия',
  'settings.variables.condition': 'Условие',
  'settings.variables.result': 'Результат',
  'settings.variables.resultTrue': 'true',
  'settings.variables.resultFalse': 'false',
  'settings.variables.valueConditions': 'value_conditions',
  'settings.variables.useDefaults': 'Подставить дефолт',
  'settings.variables.clear': 'Очистить',
  'settings.variables.l2.total_messages_in_chat': 'общий объём переписки',
  'settings.variables.l2.total_fan_messages': 'сколько сообщений отправил пользователь',
  'settings.variables.l2.messages_in_current_session': 'длина текущей сессии',
  'settings.variables.l2.session_length_minutes': 'длительность текущей сессии',
  'settings.variables.l2.messages_7d': 'активность за 7 дней',
  'settings.variables.l2.days_since_last_message': 'сколько дней с последнего сообщения',
  'settings.variables.l2.total_spend': 'общий spend',
  'settings.variables.l2.spend_30d': 'spend за 30 дней',
  'settings.variables.l2.purchase_count': 'количество покупок',
  'settings.variables.l2.ever_bought': 'была ли хотя бы одна покупка',
  'settings.variables.l2.days_since_last_purchase': 'сколько дней с последней покупки',
  'settings.variables.l2.offer_accept_rate': 'доля принятых офферов',
  'settings.variables.l2.ghost_after_offer_rate': 'доля уходов после оффера',
  'settings.variables.l2.recent_offer_rejected': 'был ли недавний отказ на оффер',
  'settings.variables.l2.preferred_tone': 'предпочитаемый стиль общения',
  'settings.variables.l2.content_preferences': 'предпочитаемые типы контента',
  'settings.variables.l2.buyer_style_hint': 'тип покупателя',
  'settings.variables.l2.conversation_style_hint': 'стиль общения',
  'settings.variables.l2.messages_since_offer': 'сообщений после оффера',
  'settings.variables.l2.relationship_stage': 'стадия отношений',
  'settings.variables.l2.monetization_stage': 'стадия монетизации',
  'settings.variables.l2.conversation_state': 'текущее состояние сценария',
  'settings.variables.l2.sale_script_allowed': 'можно включать серию продаж',
  'settings.variables.l2.direct_offer_allowed': 'можно показывать прямой оффер',
  'settings.variables.l2.upsell_allowed': 'можно делать upsell',
  'settings.variables.l2.cooldown_after_offer': 'нельзя повторять оффер прямо сейчас',
  'settings.variables.l2.current_state': 'Состояние ядра (profile.current_state, напр. POSTBUY)',
  'settings.variables.l2.postbuy_phase': 'Фаза POSTBUY (delivery, payment_pending, aftercare)',
  'settings.variables.l2.proactive_trigger': 'событие, которое запустило проверку проактива',
  'settings.variables.l2.fan_came_online': 'true, если провайдер сообщил, что фан вышел онлайн',
  'settings.variables.l2.fan_is_online': 'true, если провайдер сообщил, что фан сейчас онлайн',
  'settings.variables.l2.fan_started_typing': 'true, если провайдер сообщил, что фан печатает',
  'settings.variables.l2.fan_liked_post': 'true, если провайдер сообщил лайк поста',
  'settings.variables.l2.fan_commented_post': 'true, если провайдер сообщил комментарий к посту',
  'settings.variables.l2.physical_item_interest_score': 'уверенность в запросе на физический товар с доставкой',
  'settings.variables.l2.physical_item_active': 'true, пока активен маршрут ручной проверки физического товара',
  'settings.variables.l2.support_interest_score': 'уверенность в добровольном предложении поддержки или подарка',
  'settings.variables.l2.support_route_active': 'true, пока активен одобренный маршрут поддержки',
  'settings.variables.l2.dominant_style_score': 'уверенность в явно выраженном предпочтении динамики ролей',
  'settings.variables.l2.dominant_style_preference': 'явно запрошенная динамика ролей или стоп-сигнал',
  'settings.variables.l2.dominant_style_active': 'true только после явного согласия на адаптивный доминантный стиль',
  'settings.variables.l2.timewaster_strategy_active': 'true только для включённой стратегии длинного неоплаченного диалога с высоким tension и низким spend intent',
  'settings.transition.coreToMonetization': 'Ядро → ветка продажи',
  'settings.transition.coreToMonetizationHint': 'Условие перехода на ветку продажи.',
  'settings.transition.salesBranch': 'Переход на ветку продажи',
  'settings.transition.salesBranchHint': 'Когда условие выполняется — идём по ветке продажи (Media Selector → offer_generator → policy_safety → отправка). Когда не выполняется — по ветке чата (message_generator → policy_safety → отправка). Если условие не задано — всегда ветка чата.',
  'settings.transition.emitChatMedia': 'Бесплатное медиа в чате (emit_chat_media)',
  'settings.transition.emitChatMediaHint': 'Если условие ложно — селектор не отдаёт бесплатное чат-медиа (только текст). Если не задано — медиа разрешены (fail-open).',
  'settings.transition.postbuyBlock': 'Блок POSTBUY для монетизации',
  'settings.transition.postbuyBlockHint': 'Если условие истинно — ядро ставит allow_offer=false независимо от run_monetization (усталость от PPV при выдаче). Если ключ не задан — дополнительный блок не применяется (fail-open).',
  'settings.transition.advanceScriptOnFreeSend': 'Продвигать курсор скрипта после бесплатной отправки',
  'settings.transition.advanceScriptOnFreeSendHint': 'По умолчанию true: free-стадия скрипта +1 после успешной отправки (идемпотентно по external_id). Для DSL — «Переключить на выражение»; в параметрах есть current_state и postbuy_phase.',
  'settings.executor.title': 'Исполнитель / доставка',
  'settings.executor.intro': 'Ниже — ключи, которые читает бэкенд (graph_config_service, delivery, media selector). Скрытых параметров нет.',
  'settings.llmFallback.title': 'LLM fallback',
  'settings.llmFallback.desc': 'Управляет моделью для одноразового повтора и ручным временным fallback circuit.',
  'settings.llmFallback.active': 'Активен',
  'settings.llmFallback.inactive': 'Не активен',
  'settings.llmFallback.activate': 'Включить circuit',
  'settings.llmFallback.clear': 'Сбросить circuit',
  'settings.llmFallback.current': 'Текущий fallback',
  'settings.llmRouter.title': 'LLM роутинг по стадиям',
  'settings.llmRouter.desc': 'Переопределяет модель агента по состоянию диалога. Пустые строки наследуют модель агента.',
  'settings.llm.selectModel': 'Выбрать модель',
  'settings.llm.inheritModel': 'Наследовать модель агента',
  'settings.key.llm_fallback_to_grok_enabled': 'Включить LLM fallback',
  'settings.desc.llm_fallback_to_grok_enabled': 'Разрешает автоматические одноразовые повторы и ручной fallback circuit при сбое основного провайдера.',
  'settings.key.llm_fallback_grok_model': 'Fallback-модель',
  'settings.desc.llm_fallback_grok_model': 'Модель для fallback-повторов. Можно выбрать OpenAI, fine-tuned OpenAI, MiniMax или Grok.',
  'settings.key.llm_state_model_router_enabled': 'Включить роутинг по стадиям',
  'settings.key.bot_policy_safety_enabled': 'Модератор LLM',
  'settings.desc.bot_policy_safety_enabled': 'Включает policy_safety перед отправкой. Если выключено, LLM-модератор пропускается, но локальная валидация исходящих сообщений остаётся.',
  'settings.key.timewaster_strategy_enabled': 'Включить работу с таймвестерами',
  'settings.desc.timewaster_strategy_enabled': 'Опциональная стратегия для длинных неоплаченных диалогов с высоким tension и низким spend intent.',
  'settings.key.timewaster_min_fan_messages': 'Порог сообщений от фана',
  'settings.desc.timewaster_min_fan_messages': 'Минимальное количество входящих сообщений до возможного включения стратегии.',
  'settings.key.timewaster_high_tension_min': 'Минимальный высокий tension',
  'settings.desc.timewaster_high_tension_min': 'Минимальный sexual tension score для промпта с игривой границей ценности.',
  'settings.key.timewaster_low_spend_intent_max': 'Максимальный низкий spend intent',
  'settings.desc.timewaster_low_spend_intent_max': 'Максимальный spend intent score, который ещё считается низким намерением купить.',
  'settings.key.timewaster_reply_delay_min_seconds': 'Минимальная задержка, секунд',
  'settings.desc.timewaster_reply_delay_min_seconds': 'Нижняя граница случайной задержки ответа при активной стратегии.',
  'settings.key.timewaster_reply_delay_max_seconds': 'Максимальная задержка, секунд',
  'settings.desc.timewaster_reply_delay_max_seconds': 'Верхняя граница случайной задержки ответа при активной стратегии.',
  'settings.condition.previewTitle': 'Предпросмотр условия (JSON параметров)',
  'settings.condition.previewPasteHint':
    'Вставьте плоский JSON из кнопки «Копировать плоский JSON для предпросмотра условий» в логе сообщения, либо целиком ответ лога (condition_preview / l3+l4). Для вложенного JSON выберите снимок ниже (after ≈ решение Core).',
  'settings.condition.previewPhaseLabel': 'Снимок для l3/l4:',
  'settings.condition.previewPhaseAfter': 'after (после шага)',
  'settings.condition.previewPhaseBefore': 'before (до шага)',
  'settings.condition.previewEvaluate': 'Вычислить',
  'settings.condition.previewResult': 'Результат (только это условие)',
  'settings.condition.previewInvalidJson': 'Некорректный JSON',
  'settings.condition.monetizationGateTitle': 'Итог монетизации ядра (как в Core)',
  'settings.condition.monetizationPostbuyBlock': 'postbuy_block',
  'settings.condition.monetizationRunMonetization': 'run_monetization',
  'settings.condition.monetizationAllowOfferEffective': 'allow_offer (итог)',
  'media.group.validation.pricedNeedsPaid': 'При цене > 0 в группе должен быть хотя бы один файл с is_paid.',
  'media.group.validation.freeGroupHasPaid': 'Бесплатная группа (0–0) не может содержать is_paid.',
  'media.group.validation.noPreviewHint': 'В платной группе нет бесплатного превью — в OF пакет может быть полностью закрыт.',
  'chats.funnel.title': 'Диагностика воронки',
  'chats.funnel.loading': 'Загрузка профиля…',
  'chats.funnel.error': 'Не удалось загрузить профиль бота',
  'chats.funnel.buyerStyle': 'Стиль покупателя',
  'chats.funnel.conversationStyle': 'Стиль диалога',
  'chats.funnel.adaptiveStyle': 'Адаптивная манера общения',
  'chats.funnel.style.active': 'активна',
  'chats.funnel.style.noData': 'недостаточно данных',
  'chats.funnel.style.confidence': 'Уверенность в стиле',
  'chats.funnel.style.directness': 'Прямота',
  'chats.funnel.style.warmth': 'Потребность в теплоте',
  'chats.funnel.style.playfulness': 'Игривость',
  'chats.funnel.style.detail': 'Предпочтение деталей',
  'chats.funnel.style.pace': 'Темп',
  'settings.transition.coreToScriptGenerator': 'Ядро → Message Generator',
  'settings.transition.coreToScriptGeneratorHint': 'Когда не выполняется условие ветки продажи — идём по ветке чата.',
  'settings.transition.useDefault': 'Подставить дефолт',
  'settings.config.title': 'Конфигурация',
  'settings.config.importFromCurrent': 'Импорт из текущих настроек',
  'settings.config.create': 'Создать',
  'settings.config.createModalTitle': 'Новая конфигурация',
  'settings.config.empty': 'Нет конфигов. Создайте конфигурацию.',
  'settings.config.active': 'Активный',
  'settings.config.activate': 'Активировать',
  'settings.config.clone': 'Клонировать',
  'settings.config.delete': 'Удалить',
  'settings.config.deleteConfirm': 'Удалить конфиг?',
  'settings.config.activateConfirmTitle': 'Активировать конфигурацию?',
  'settings.config.activateConfirmMessage': 'При переключении конфигурации все пользователи (не тестеры) будут использовать эту конфигурацию. У тестеров своя конфигурация сохраняется отдельно.',
  'settings.config.imported': 'Конфиг создан из текущих настроек',
  'settings.config.created': 'Конфиг создан',
  'settings.config.cloned': 'Конфиг склонирован',
  'settings.config.rename': 'Переименовать',
  'settings.config.renameModalTitle': 'Переименовать конфигурацию',
  'settings.config.renamed': 'Конфиг переименован',
  'settings.config.activated': 'Конфиг активирован',
  'settings.config.deleted': 'Конфиг удалён',
  'settings.config.errorLoad': 'Ошибка загрузки',
  'settings.config.namePrompt': 'Название конфига:',
  'settings.config.notFound': 'Конфигурация не найдена',
  'settings.config.backToList': 'К списку',
  'settings.config.edit': 'Редактировать',
  'settings.deleteConditionTitle': 'Удалить условие?',
  'settings.deleteConditionMessage': 'Условие будет удалено.',
  'settings.deleteRuleTitle': 'Удалить правило?',
  'settings.deleteRuleMessage': 'Правило будет удалено.',
  'settings.deleteConditionalPromptTitle': 'Удалить условный промпт?',
  'settings.deleteConditionalPromptMessage': 'Условный промпт будет удалён.',
  'settings.loading': 'Загрузка…',
  'settings.promptsHint': 'Переменные: {{payload_json}}, {{model_persona}}, {{explicit_level}} и др.',
  'settings.agent.model': 'Модель (LLM-провайдер)',
  'settings.agent.asyncMode': 'асинхронный',
  'settings.agent.asyncModelsHint': 'Модели с пометкой (асинхронный) — webhook, без polling. Остальные: sync или polling.',
  'settings.agent.temperature': 'Temperature',
  'settings.agent.top_p': 'Top P',
  'settings.agent.top_p_hint': 'Nucleus sampling (0–1). Использовать с temperature, не оба.',
  'settings.agent.max_tokens': 'Max tokens',
  'settings.agent.max_tokens_hint': 'Максимальная длина ответа.',
  'settings.agent.frequency_penalty': 'Frequency penalty',
  'settings.agent.frequency_penalty_hint': '-2 до 2. Штраф за повторяющиеся токены.',
  'settings.agent.presence_penalty': 'Presence penalty',
  'settings.agent.presence_penalty_hint': '-2 до 2. Штраф за уже упомянутые темы.',
  'settings.agent.conversationMessagesCount': 'Сообщений переписки в контексте',
  'settings.agent.label.message_analyzer': 'Анализатор сообщений',
  'settings.agent.label.photo_analyzer': 'Анализатор фото',
  'settings.agent.label.script_generator': 'Генератор сообщений', // legacy, отображается как message_generator
  'settings.agent.label.message_generator': 'Генератор сообщений',
  'settings.agent.label.photo_generator': 'Генератор ответов на фото',
  'settings.agent.label.monetization': 'Генератор офферов',
  'settings.agent.label.policy_safety': 'Модератор контента',
  'settings.agent.label.memory_summary': 'Суммаризатор памяти',
  'settings.agent.label.offer_generator': 'Оффер-генератор',
  'settings.agent.label.proactive_message_generator': 'Проактивный генератор',
  'settings.prompt.placeholder': 'Текст промпта…',
  'settings.prompt.roleSystem': 'Системный промпт',
  'settings.prompt.roleUser': 'Пользовательский промпт',
  'settings.prompt.baseLabel': 'Базовый промпт',
  'settings.prompt.extraLabel': 'Дополнительные промпты (всегда добавляются к базовому)',
  'settings.prompt.extraPlaceholder': 'Текст дополнительного промпта…',
  'settings.prompt.addExtra': '+ Добавить дополнительный промпт',
  'settings.prompt.userReadonlyHint': 'В пользовательский промпт передаётся JSON с данными (структура ниже). Редактирование недоступно — шаблон фиксирован.',
  'settings.prompt.payload.object': 'объект',
  'settings.prompt.payload.ma.incoming_messages': 'входящие сообщения текущего батча [{role, text}]',
  'settings.prompt.payload.ma.conversation_history': 'последние N сообщений переписки [{role, text}]',
  'settings.prompt.payload.ma.conversation_messages_count': 'сколько сообщений в conversation_history (настройка)',
  'settings.prompt.payload.ma.responseFormatTitle': 'Структура ответа (text.format)',
  'settings.prompt.payload.ma.responseFormatDesc': 'Эта структура передаётся в специальное поле API (text.format) и гарантирует, что LLM вернёт JSON строго в этом формате.',
  'settings.prompt.payload.generator.outputFormatTitle': 'Формат ответа',
  'settings.prompt.payload.generator.outputFormatDesc': 'Структура, которую должен вернуть LLM. Передайте в user-промпт и попросите модель вернуть строго этот формат (JSON или plain text).',
  'settings.prompt.payload.ma.output.intent': 'тип сообщения',
  'settings.prompt.payload.ma.output.tone': 'эмоциональный тон',
  'settings.prompt.payload.ma.output.trust_score': 'уровень доверия',
  'settings.prompt.payload.ma.output.attachment_score': 'эмоциональная привязанность',
  'settings.prompt.payload.ma.output.sexual_tension_score': 'сексуальное напряжение',
  'settings.prompt.payload.ma.output.spending_score': 'склонность к трате',
  'settings.prompt.payload.ma.output.resistance_score': 'сопротивление',
  'settings.prompt.payload.ma.output.user_arousal_score': 'возбуждён ли пользователь',
  'settings.prompt.payload.ma.output.user_is_alone_score': 'вероятность, что пользователь один',
  'settings.prompt.payload.ma.output.user_privacy_score': 'есть ли приватность',
  'settings.prompt.payload.ma.output.user_has_time_score': 'есть ли время продолжать',
  'settings.prompt.payload.ma.output.buy_signal': 'прямой сигнал покупки',
  'settings.prompt.payload.ma.output.realness_test_score': 'проверка «реальная ли модель»',
  'settings.prompt.payload.ma.output.policy_risk_score': 'рискованный запрос',
  'settings.prompt.payload.ma.output.risk_flag': 'блокировать граф (SAFETY_LOCK)',
  'settings.prompt.payload.ma.output.risk_reason': 'причина при risk_flag',
  'settings.prompt.payload.sg.tone_style': 'стиль тона: girlfriend, seductive, flirty и др.',
  'settings.prompt.payload.sg.explicit_level': 'уровень откровенности 0–100',
  'settings.prompt.payload.sg.message_length': 'длина ответа: short, medium, long',
  'settings.prompt.payload.sg.user_profile': 'числовой профиль фана (engagement, attachment и т.д.)',
  'settings.prompt.payload.sg.incoming_messages': 'входящие сообщения (массив элементов)',
  'settings.prompt.payload.sg.model_persona': 'описание персонажа модели (account_description)',
  'settings.prompt.payload.sg.recent_messages': 'массив последних сообщений [{role, text}]',
  'settings.prompt.payload.sg.media_hint': 'подсказка по медиа (если продаём контент) или null',
  'settings.prompt.payload.sg.send_delay_min_seconds': 'мин. задержка перед отправкой (сек)',
  'settings.prompt.payload.sg.send_delay_max_seconds': 'макс. задержка перед отправкой (сек)',
  'settings.prompt.payload.mo.payment_score': 'готовность к платежу (spending_intent)',
  'settings.prompt.payload.mo.relationship_score': 'уровень отношений (emotional_attachment)',
  'settings.prompt.payload.mo.sexual_level': 'сексуальное напряжение',
  'settings.prompt.payload.mo.days_since_last_purchase': 'дней с последней покупки',
  'settings.prompt.payload.mo.resistance_level': 'уровень сопротивления',
  'settings.prompt.payload.mo.price_sensitivity': 'чувствительность к цене',
  'settings.prompt.payload.mo.purchase_count': 'количество покупок у этого фана',
  'settings.prompt.payload.mo.state': 'текущий стейт (FLIRT, PRESELL и т.д.)',
  'settings.prompt.payload.mo.allow_offer': 'разрешён ли оффер (решение Ядра)',
  'settings.prompt.payload.dg.media_info': 'метаданные медиа (price_min, price_max, описание)',
  'settings.prompt.payload.dg.client_context': 'контекст клиента для персонализации',
  'settings.prompt.payload.dg.current_state': 'текущий стейт фана',
  'settings.prompt.payload.dg.spending_intent_score': 'готовность тратить',
  'settings.prompt.payload.dg.price_sensitivity': 'чувствительность к цене',
  'settings.prompt.payload.dg.relationship_summary': 'сводка по отношениям (user_profile)',
  'settings.prompt.payload.dg.tone_style': 'стиль тона',
  'settings.prompt.payload.dg.explicit_level': 'уровень откровенности',
  'settings.prompt.payload.dg.model_persona': 'персона модели',
  'settings.prompt.payload.dg.incoming_messages': 'входящие сообщения (массив элементов)',
  'settings.prompt.payload.og.user_profile': 'профиль фана (результат memory_summary)',
  'settings.prompt.payload.og.media_info': 'группа медиа с описанием (price_min, price_max, description)',
  'settings.prompt.payload.og.model_persona': 'персона модели',
  'settings.prompt.payload.og.incoming_messages': 'последние N сообщений переписки (массив {role, text})',
  'settings.prompt.payload.ms.existing_user_profile': 'текущий профиль фана (что уже знаем)',
  'settings.prompt.payload.ms.recent_messages': 'последние сообщения из переписки',
  'settings.prompt.payload.ps.candidate_reply_preview': 'превью ответа для проверки на безопасность',
  'settings.prompt.payload.ps.explicit_level': 'уровень откровенности',
  'settings.prompt.payload.ps.tone_style': 'стиль тона',
  'settings.prompt.payload.ps.message_length': 'длина сообщения',
  'settings.prompt.payload.pmg.state': 'текущий стейт (для follow-up)',
  'settings.prompt.payload.pmg.recent_messages': 'последние сообщения в диалоге',
  'settings.prompt.payload.pmg.model_persona': 'персона модели',
  'settings.prompt.payload.pmg.tone_style': 'стиль тона',
  'settings.prompt.payload.pmg.explicit_level': 'уровень откровенности',
  'settings.conditionalPrompts.title': 'Дополнительные промпты (по условию)',
  'settings.conditionalPrompts.hint': 'Добавляйте текст к основному промпту, когда числовые параметры выполняют условие. Простое (параметр, оператор, значение) или сложное (И/ИЛИ).',
  'settings.conditionalPrompts.conditionLabel': 'Условие (числовые параметры):',
  'settings.conditionalPrompts.promptLabel': 'Доп. текст (добавляется к основному промпту):',
  'settings.conditionalPrompts.roleLabel': 'Роль:',
  'settings.conditionalPrompts.orderLabel': 'Порядок:',
  'settings.conditionalPrompts.addRule': '+ Добавить условный промпт',
  'settings.conditionalPrompts.promptPlaceholder': 'Текст, который добавится при выполнении условия',
  'settings.condition.simple': 'Простое',
  'settings.condition.complex': 'Сложное (И/ИЛИ)',
  'settings.condition.plainBoolTrue': 'Всегда true',
  'settings.condition.plainBoolFalse': 'Всегда false',
  'settings.condition.plainBoolDefaultHint': 'В JSON ключ не задан — на бэкенде это трактуется как true (продвижение после бесплатной отправки).',
  'settings.condition.plainBoolForceTrue': 'Записать: всегда true',
  'settings.condition.plainBoolForceFalse': 'Записать: всегда false',
  'settings.condition.switchToExpression': 'Условие (DSL)…',
  'settings.condition.clearToBackendDefault': 'Убрать ключ (дефолт бэкенда)',
  'settings.condition.addCondition': '+ Добавить условие',
  'settings.condition.and': 'И',
  'settings.condition.or': 'ИЛИ',
  'params.title': 'Параметры',
  'params.engagement_score': 'Вовлечённость',
  'params.emotional_attachment_score': 'Эмоциональная привязанность',
  'params.sexual_tension_score': 'Сексуальное напряжение',
  'params.spending_intent_score': 'Готовность тратить',
  'params.resistance_level': 'Сопротивление',
  'params.price_sensitivity': 'Чувствительность к цене',
  'params.risk_of_churn': 'Риск оттока',
  'params.content_readiness_score': 'Готовность к контенту',
  'params.intimacy_score': 'Интимность',
  'params.total_messages_in_chat': 'Всего сообщений',
  'params.total_fan_messages': 'Сообщений от фана',
  'params.messages_in_current_session': 'Сообщений в текущей сессии',
  'params.session_length_minutes': 'Длительность сессии (мин)',
  'params.messages_7d': 'Сообщений за 7 дней',
  'params.days_since_last_message': 'Дней с последнего сообщения',
  'params.total_spend': 'Сумма покупок',
  'params.spend_30d': 'Сумма за 30 дней',
  'params.purchase_count': 'Количество покупок',
  'params.ever_bought': 'Была покупка',
  'params.days_since_last_purchase': 'Дней с последней покупки',
  'params.offer_accept_rate': 'Доля принятых офферов',
  'params.ghost_after_offer_rate': 'Уходы после оффера',
  'params.recent_offer_rejected': 'Недавний отказ на оффер',
  'params.preferred_tone': 'Предпочитаемый тон',
  'params.content_preferences': 'Предпочитаемый контент',
  'params.buyer_style_hint': 'Стиль покупателя',
  'params.conversation_style_hint': 'Стиль общения',
  'params.messages_since_offer': 'Сообщений после оффера',
  'params.relationship_stage': 'Стадия отношений',
  'params.monetization_stage': 'Стадия монетизации',
  'params.conversation_state': 'Состояние сценария',
  'params.proactive_trigger': 'Триггер проактива',
  'params.fan_came_online': 'Фан вышел онлайн',
  'params.fan_is_online': 'Фан онлайн',
  'params.fan_started_typing': 'Фан начал печатать',
  'params.fan_liked_post': 'Фан лайкнул пост',
  'params.fan_commented_post': 'Фан оставил комментарий',
  'params.sale_script_allowed': 'Серию продаж можно',
  'params.direct_offer_allowed': 'Прямой оффер можно',
  'params.upsell_allowed': 'Upsell можно',
  'params.cooldown_after_offer': 'Cooldown после оффера',
  'settings.hasSettings': 'Есть настройки',
  'settings.noSettings': 'Настроек нет',
  'settings.node.label.in': 'Входящее сообщение',
  'settings.node.label.core': 'Ядро',
  'settings.node.label.media_selector': 'Селектор медиа',
  'settings.node.label.send': 'Отправка',
  'settings.nodeHint.in': 'Только принимает входящие сообщения. Настройки не требуются.',
  'settings.nodeHint.core': 'Параметры L3 (engagement, spending_intent и др.) считаются из L1 (анализатор) + L2. Вся логика — в разделе Переменные.',
  'settings.nodeHint.coreGoToVariables': '→ Переменные, уровень L3',
  'settings.nodeHint.media_selector': 'Выбирает медиа по скрипту. Настройки — в разделе медиа.',
  'settings.nodeDesc.in': 'Входящий узел: debounce объединяет сообщения в один ввод; TTL защищает от зависших задач; save retry — повтор при ошибке сохранения. Количество сообщений переписки — в настройках каждого агента.',
  'settings.nodeDesc.core': 'Ядро обновляет параметры L3 по сигналам от анализатора (signal→delta, clamp 0–100). Переходы — условиями в Связях.',
  'settings.core.graphTransitionsHeading': 'Блок монетизации postbuy_block (ниже числовых полей ядра)',
  'settings.nodeDesc.media_selector': '',
  'settings.mediaSelector.intro': 'Media Selector выбирает медиа по ветке (чат или продажа). Ядро задаёт allow_offer через run_monetization; emit_chat_media — шлюз бесплатного чат-медиа. Полностью бесплатная стадия скрипта может отдаваться через sales-хинт без offer_generator — см. advance_script_on_free_send.',
  'settings.mediaSelector.salesTitle': 'Ветка продажи (trigger_offer + allow_offer)',
  'settings.mediaSelector.salesSessionTitle': 'Выбор фотосессии',
  'settings.mediaSelector.salesSession1': 'Берём текущую сессию из профиля (current_script_session_id).',
  'settings.mediaSelector.salesSession2Before': 'Переключаем, если: нет текущей сессии; или time_tag сессии ≠ текущему времени суток (утро 6–11, день 12–17, вечер 18–22, ночь 23–5) и прошло ≥ ',
  'settings.mediaSelector.salesSession2After': ' ч; иначе остаёмся.',
  'settings.mediaSelector.salesSession3': 'При выборе: приоритет по time_tag (часовой пояс модели), иначе last_chat_session_id.',
  'settings.mediaSelector.salesGroupTitle': 'Выбор группы внутри сессии',
  'settings.mediaSelector.salesGroup1': 'Только скрипт-сессии (is_script=True) с группами (price_min, price_max).',
  'settings.mediaSelector.salesGroup2': 'Порядок: MediaGroup.sort_order → group_sort_order → session_sort_order → id.',
  'settings.mediaSelector.routingHeading': 'Маршрутизация (продажа vs чат)',
  'settings.mediaSelector.salesGroup3': 'current_script_stage_index — номер стадии (MediaGroup по порядку скрипта). Продвижение +1 после терминального события: только free-стадия → успешная отправка (настраивается); paid/mixed → webhook оплаты.',
  'settings.mediaSelector.chatTitle': 'Ветка чата (без оффера)',
  'settings.mediaSelector.chat1': 'Исключаем скрипт-сессии (is_script=True).',
  'settings.mediaSelector.chat2Before': 'Исключаем медиа, отправленные фану за последние ',
  'settings.mediaSelector.chat2After': ' дней.',
  'settings.mediaSelector.chat3': 'Ограничение: L3 intimacy_score → max_hotness (0–20→3, 20–40→5, 40–60→7, 60–80→8, 80+→10).',
  'settings.mediaSelector.chat4': 'Сортировка: hotness DESC, updated_at DESC.',
  'settings.mediaSelector.chat5': 'Берём первый подходящий медиа (одно, не группа).',
  'settings.mediaSelector.transitionTitle': 'Переход на ветку продажи',
  'settings.mediaSelector.transitionText': 'Условие run_monetization (блок ниже). Выполняется → offer_generator → policy_safety → отправка. Не выполняется → message_generator → policy_safety → отправка.',
  'settings.nodeDesc.send': 'Диапазон задержки перед отправкой (min/max/default), typing indicator, retry при ошибке API.',
  'settings.params': 'параметров',
  'settings.selectSection': 'Выберите раздел в меню слева.',
  'settings.nodesHint': 'Узлы пайплайна. Клик по узлу на схеме — настройки.',
  'settings.diagramClickHint': 'Нажмите для редактирования',
  'settings.agentNotFound': 'агент не найден',
  'settings.nodeNotFound': 'узел не найден',
  'settings.edgeNotFound': 'связь не найдена',
  'settings.renderError': 'Ошибка рендера',

  // Схема графа (diagram)
  'diagram.loading': 'Загрузка графа…',
  'diagram.in': 'Вход',
  'diagram.messageAnalyzer': 'Анализатор сообщений',
  'diagram.memorySummarizer': 'Суммаризатор памяти',
  'diagram.llmAgents': 'LLM-агенты',
  'diagram.messageGenerator': 'Генератор сообщений',
  'diagram.contentModerator': 'Модератор контента',
  'diagram.offerGenerator': 'Оффер-генератор',
  'diagram.ruleBased': 'Правила',
  'diagram.core': 'Ядро',
  'diagram.mediaSelector': 'Селектор медиа',
  'diagram.send': 'Отправка',
  'diagram.incomingMessage': 'Входящее сообщение',
  'diagram.parallel': 'параллельно',
  'diagram.memorySummarizerEvery10': 'Суммаризатор памяти (каждые 10 msg)',
  'diagram.sendSale': 'Отправка (продажа)',
  'diagram.sendChat': 'Отправка (чат, можно с медиа)',
  'diagram.parallelNote': 'Анализатор и Суммаризатор запускаются параллельно, ждут друг друга → Ядро',
  'diagram.proactiveFlow': 'Проактивный бот',
  'diagram.proactiveBot': 'Проактивный бот',
  'diagram.proactiveGenerator': 'Проактивный генератор',

  // Подписи ключей настроек (settings.key.<key>)
  'settings.key.bot_debounce_seconds': 'Debounce (сек)',
  'settings.key.bot_running_graph_ttl_seconds': 'TTL активного графа (сек)',
  'settings.key.bot_pending_task_ttl_seconds': 'TTL задачи в очереди (сек)',
  'settings.key.bot_delayed_send_ttl_seconds': 'TTL отложенной отправки (сек)',
  'settings.key.bot_send_delay_min_ms': 'Мин. задержка перед отправкой (мс)',
  'settings.key.bot_send_delay_max_ms': 'Макс. задержка перед отправкой (мс)',
  'settings.key.bot_send_delay_default_ms': 'Задержка по умолчанию (мс)',
  'settings.key.bot_typing_indicator_enabled': 'Индикатор набора (1/0)',
  'settings.key.bot_send_retry_attempts': 'Макс. попыток отправки',
  'settings.key.bot_send_retry_backoff_ms': 'База backoff между повторами (мс)',
  'settings.key.bot_send_split_enabled': 'Разбивать длинные отправки (1/0)',
  'settings.key.bot_send_split_max_chunk_length': 'Split: макс. символов в чанке',
  'settings.key.bot_send_split_inter_chunk_delay_seconds': 'Split: пауза между чанками (сек)',
  'settings.key.bot_send_split_max_chunks': 'Split: макс. чанков на сообщение',
  'settings.key.bot_send_strict_paid_invariants': 'Строгие инварианты PPV (1/0)',
  'settings.key.bot_save_retry_delay_seconds': 'Задержка повтора сохранения (сек)',
  'settings.key.bot_save_retry_max_attempts': 'Макс. попыток сохранения',
  'settings.key.policy_risk_safety_lock_threshold': 'Порог SAFETY_LOCK по policy_risk',
  'settings.key.bot_core_score_delta_scale': 'Множитель scale (score -> delta)',
  'settings.key.bot_core_max_delta': 'Макс. дельта за сообщение (max_delta)',
  'settings.key.bot_context_messages_count': 'Сообщений в контексте',
  'settings.key.message_analyzer_conversation_messages_count': 'Сообщений переписки для анализатора',
  'settings.key.bot_silence_followup_rapport_hours': 'Follow-up RAPPORT (ч)',
  'settings.key.bot_silence_followup_rapport_returned_hours': 'Follow-up RAPPORT returned (ч)',
  'settings.key.bot_silence_followup_flirt_hours': 'Follow-up FLIRT (ч)',
  'settings.key.bot_silence_followup_presell_hours': 'Follow-up PRESELL (ч)',
  'settings.key.bot_silence_followup_offer_hours': 'Follow-up OFFER (ч)',
  'settings.key.bot_silence_followup_postbuy_hours': 'Follow-up POSTBUY (ч)',
  'settings.key.bot_silence_followup_cooldown_hours': 'Follow-up COOLDOWN (ч)',
  'settings.key.bot_session_switch_min_hours': 'Session switch мин. часов (ч)',
  'settings.key.bot_chat_media_recent_days': 'Chat media: недавние (дней)',
  // Описания настроек (settings.desc.<key>)
  'settings.desc.bot_debounce_seconds': 'Ожидание перед запуском графа после последнего сообщения. Все сообщения за этот период объединяются в один ввод.',
  'settings.desc.bot_running_graph_ttl_seconds': 'TTL ключа «граф работает» в Redis. Защита от зависших задач.',
  'settings.desc.bot_pending_task_ttl_seconds': 'TTL задачи в очереди debounce. Если граф не стартовал за это время — задача отменяется.',
  'settings.desc.bot_delayed_send_ttl_seconds': 'TTL отложенной отправки. Если за это время пришло новое сообщение — отправка отменяется, запускается новый граф.',
  'settings.desc.bot_send_delay_min_ms': 'Нижняя граница случайной паузы перед отправкой (равномерно).',
  'settings.desc.bot_send_delay_max_ms': 'Верхняя граница случайной паузы перед отправкой.',
  'settings.desc.bot_send_delay_default_ms': 'Если suggested_delay_seconds вне min/max — используется случайное в диапазоне.',
  'settings.desc.bot_typing_indicator_enabled': 'Если 1 — вызов typing API перед отправкой (и в отложенной отправке по расписанию).',
  'settings.desc.bot_send_retry_attempts': 'Повторы при 429/5xx/сети после срабатывания отложенной отправки.',
  'settings.desc.bot_send_retry_backoff_ms': 'База экспоненциального backoff между попытками.',
  'settings.desc.bot_send_split_enabled': 'Если 1 — длинный исходящий текст режется на несколько отправок к провайдеру.',
  'settings.desc.bot_send_split_max_chunk_length': 'Максимум символов в одном чанке при включённом split.',
  'settings.desc.bot_send_split_inter_chunk_delay_seconds': 'Пауза между чанками (естественный темп).',
  'settings.desc.bot_send_split_max_chunks': 'Предохранитель: не больше стольки чанков.',
  'settings.desc.bot_send_strict_paid_invariants': 'Если 1 — блокировать отправку при противоречии price / превью / paid.',
  'settings.key.bot_typing_duration_seconds': 'Длительность индикатора (сек)',
  'settings.key.bot_typing_interval_seconds': 'Интервал повтора typing (сек)',
  'settings.key.bot_typing_chars_per_call': 'Символов на доп. вызов typing',
  'settings.desc.bot_typing_duration_seconds': 'Один вызов API typing показывает индикатор примерно столько секунд.',
  'settings.desc.bot_typing_interval_seconds': 'Как часто повторять вызов typing при длинной задержке.',
  'settings.desc.bot_typing_chars_per_call': 'Каждые N символов сообщения — дополнительный вызов typing.',
  'settings.desc.bot_save_retry_delay_seconds': 'Пауза между попытками сохранения в БД при ошибке.',
  'settings.desc.bot_save_retry_max_attempts': 'Максимум попыток сохранения в БД.',
  'settings.desc.policy_risk_safety_lock_threshold': 'Если policy_risk_score >= этого значения, выставляется risk_flag и граф переходит в SAFETY_LOCK (без ответа). 0–100.',
  'settings.desc.bot_core_score_delta_scale': 'Дефолт: 0.2. Формула для scores анализатора: delta = (score - 50) * scale.',
  'settings.desc.bot_core_max_delta': 'Дефолт: 15. Максимальное изменение любого параметра L3 за шаг (ограничение ±max_delta).',
  'settings.desc.bot_context_messages_count': 'Сколько последних сообщений чата передавать в LLM как контекст.',
  'settings.desc.message_analyzer_conversation_messages_count': 'Сколько последних сообщений переписки передавать в анализатор (conversation_history). Редактируется в настройках, используется в промпте как {{conversation_messages_count}}.',
  'settings.desc.message_generator_conversation_messages_count': 'Сколько последних сообщений передавать в message_generator (recent_messages в payload).',
  'settings.desc.memory_summary_conversation_messages_count': 'Сколько последних сообщений передавать в memory_summary (recent_messages в payload).',
  'settings.key.memory_summary_run_every_n_messages': 'Запускать каждые N сообщений',
  'settings.desc.memory_summary_run_every_n_messages': 'Суммаризатор памяти запускается, когда messages_processed_count фана пересекает кратное N (10, 20, 30…). По умолчанию 10.',
  'settings.desc.proactive_message_generator_conversation_messages_count': 'Сколько последних сообщений передавать в proactive_message_generator (recent_messages в payload).',
  'settings.desc.offer_generator_conversation_messages_count': 'Сколько последних сообщений передавать в offer_generator (incoming_messages в payload).',
  'settings.desc.bot_silence_followup_rapport_hours': 'Follow-up — бот сам пишет фану, если тот не отвечал N часов. Порог для RAPPORT (новый фан, ещё мало общались).',
  'settings.desc.bot_silence_followup_rapport_returned_hours': 'Follow-up — бот сам пишет фану после молчания. Порог для RAPPORT, когда фан вернулся после паузы (уже был диалог).',
  'settings.desc.bot_silence_followup_flirt_hours': 'Follow-up — бот сам пишет фану после молчания. Порог для стейта FLIRT (флирт, прогрев).',
  'settings.desc.bot_silence_followup_presell_hours': 'Follow-up — бот сам пишет фану после молчания. Порог для стейта PRESELL (продаём, но ещё не оффер).',
  'settings.desc.bot_silence_followup_offer_hours': 'Follow-up — бот сам пишет фану после молчания. Порог для стейта OFFER (активная продажа).',
  'settings.desc.bot_silence_followup_postbuy_hours': 'Follow-up — бот сам пишет фану после молчания. Порог для стейта POSTBUY (только что купил, aftercare).',
  'settings.desc.bot_silence_followup_cooldown_hours': 'Follow-up — бот сам пишет фану после молчания. Порог для стейта COOLDOWN (пауза после покупки/оффера).',
  'settings.desc.bot_session_switch_min_hours': 'Минимум часов между переключениями фотосессии. Формула: переключаем, если (current_session.time_tag ≠ current_time_tag) И (elapsed_hours ≥ N), где elapsed_hours = (now − last_script_session_changed_at) / 3600. Защита от «дали сессию, через 10 мин фан пишет — уже другая».',
  'settings.desc.bot_chat_media_recent_days': 'Сколько дней считать медиа «недавно отправленным» фану. Исключаем из выбора медиа, отправленные за последние N дней. Формула: recent_cutoff = now − N дней.',
  // Models list
  'models.title': 'Модели',
  'models.add': '+ Добавить модель',
  'models.loading': 'Загрузка…',
  'models.empty': 'Нет моделей. Добавьте первую.',
  'models.account.ok': 'Модель используется для переписки и продажи — описание аккаунта заполнено',
  'models.account.bad':
    'Модель пока не используется для переписки или продажи — заполните описание аккаунта',
  'models.account.bad.prefix': 'Модель пока не используется для переписки или продажи — ',
  'models.account.bad.description': 'заполните описание аккаунта',
  'models.account.bad.timezone': 'заполните часовой пояс',
  'models.account.bad.both': 'заполните описание и часовой пояс',
  'models.connection.edit': 'Редактирование подключения',
  'models.connection.info': 'Инфо и история подключений',
  'models.connection.delete': 'Удалить',
  'models.connection.connected': 'Подключено',
  'models.connection.connecting': 'Подключение…',
  'models.connection.pending': 'Не подключено',
  'models.connection.stop': 'Остановить подключение',
  'models.connection.unlink':
    'Отключить привязку (только у нас, у провайдера останется)',
  'models.connection.connect': 'Подключить',
  'models.connectModal.titleCreate': 'Добавить модель',
  'models.connectModal.titleEdit': 'Редактирование подключения',
  'models.connectModal.password': 'Пароль',
  'models.connectModal.passwordUnchangedPlaceholder': 'Оставьте пустым, чтобы не менять',
  'models.connectModal.testModel': 'Тестовая модель (для автотестов)',
  'models.connectModal.validationRequiredCreate': 'Введите email и пароль',
  'models.connectModal.validationRequiredEdit': 'Введите email',
  'models.twoFa.descriptionWithModel':
    'Модель: {model}. Введите код 2FA, если включён на аккаунте OnlyFans.',
  'models.twoFa.description':
    'Введите код 2FA, если на аккаунте включена двухфакторная аутентификация.',
  'models.twoFa.connect': 'Подключить',
  'models.twoFa.label': '2FA (необязательно)',
  'models.twoFa.placeholder': 'Код из приложения аутентификации',
  'models.delete.title': 'Удалить модель?',
  'models.delete.message':
    'Модель «{name}», все подключения к провайдерам, медиа и всё связанное будут удалены. Это действие нельзя отменить.',
  'models.disconnect.title': 'Отключить провайдера?',
  'models.disconnect.message':
    'Привязку {provider} для модели «{model}» удалят только у нас. У провайдера подключение останется — при повторном подключении оно подтянется автоматически.',
  'models.disconnect.confirm': 'Отключить',
  'models.disconnect.progress': 'Отключение…',
  'models.onlyfansapi.2fa.title': 'Подключение к OnlyFans API',

  // Model detail
  'modelDetail.backToList': '← К списку',
  'modelDetail.fallbackName': 'Модель',
  'modelDetail.sync.progress': 'Синхронизация…',
  'modelDetail.sync.done': 'Синхронизировано',
  'modelDetail.sync.error': 'Ошибка',
  'modelDetail.account.ok':
    'Модель используется для переписки и продажи — описание аккаунта заполнено',
  'modelDetail.account.bad':
    'Модель пока не используется для переписки или продажи — заполните описание аккаунта',
  'modelDetail.account.bad.prefix': 'Модель пока не используется для переписки или продажи — ',
  'modelDetail.account.bad.description': 'заполните описание аккаунта',
  'modelDetail.account.bad.timezone': 'заполните часовой пояс',
  'modelDetail.account.bad.both': 'заполните описание и часовой пояс',
  'modelDetail.loading': 'Загрузка…',
  'modelDetail.account.loading': 'Загрузка данных аккаунта…',
  'modelDetail.account.sectionLabel': 'Аккаунт',
  'modelDetail.account.name': 'Имя',
  'modelDetail.account.username': 'Username',
  'modelDetail.account.email': 'Email',
  'modelDetail.account.subscribePrice': 'Цена подписки ($)',
  'modelDetail.account.credits': 'Кредиты (мин–макс)',
  'modelDetail.account.subscribers': 'Подписчики',
  'modelDetail.account.posts': 'Постов',
  'modelDetail.account.localDescription': 'Описание (локальное)',
  'modelDetail.account.timezone': 'Часовой пояс',
  'modelDetail.account.timezone.label': 'Часовой пояс',
  'modelDetail.account.timezone.placeholder': 'Начните вводить, например: Europe/Moscow',
  'modelDetail.account.defaultConfig.label': 'Конфиг модели по умолчанию',
  'modelDetail.account.defaultConfig.hint': 'Используется при создании нового профиля чата для этой модели.',
  'modelDetail.account.editAria': 'Редактировать описание аккаунта',
  'modelDetail.account.delete.title': 'Удалить модель?',
  'modelDetail.account.delete.message':
    'Модель «{name}», все подключения к провайдерам, медиа и всё связанное будут удалены. Это действие нельзя отменить.',
  'modelDetail.account.description.modalTitle': 'Описание аккаунта',
  'modelDetail.account.description.label': 'Описание аккаунта',
  'modelDetail.account.description.placeholder':
    'Произвольное описание аккаунта для внутреннего использования',
  'modelDetail.account.description.saveError': 'Не удалось сохранить описание аккаунта',
  'modelDetail.account.maxMessagePrice.label': 'Макс. цена сообщения (PPV), $',
  'modelDetail.account.maxMessagePrice.placeholder': 'пусто — дефолт из настроек',
  'modelDetail.account.maxMessagePrice.hint': 'Целое число в диапазоне 3–200. Пусто — используется значение из общих настроек бота.',
  'modelDetail.account.maxMessagePrice.invalid': 'Цена должна быть целым числом в диапазоне 3–200 (или пустой).',
  'modelDetail.connectionHistory.title': 'История подключений',
  'modelDetail.connectionHistory.empty': 'Нет событий',

  // Media
  'media.used.ok':
    'Медиа используется — все параметры заполнены, всё в порядке',
  'media.used.bad':
    'Медиа пока не используется для переписки или продажи — заполните описание, горячесть и части тела',
  'media.used.notActive': 'Медиа не активно.',
  'media.used.excluded': 'Медиа исключено из автоматического использования.',
  'media.used.fillPrompt': 'Заполните:',
  'media.used.missing.price': 'цена',
  'media.used.missing.description': 'описание',
  'media.used.missing.hotness': 'горячесть',
  'media.used.missing.bodyParts': 'части тела',
  'media.type.video': 'Видео',
  'media.type.audio': 'Аудио',
  'media.type.photo': 'Фото',
  'media.type.gif': 'GIF',
  'media.type.unknown': 'Тип неизвестен',
  'media.count.photo': '{count} фото',
  'media.count.video': '{count} видео',
  'media.count.audio': '{count} аудио',
  'media.count.gif': '{count} GIF',
  'media.count.unknown': '{count} неизвестного типа',
  'media.composition.hint': 'Состав загруженных медиа этого шага',
  'media.library.remove': 'Убрать из библиотеки',
  'media.library.confirm': 'Подтвердить изменение',
  'media.library.restore': 'Восстановить в библиотеке',
  'media.library.removeHint': 'Медиа исчезнет из библиотеки FanLTV, и бот не сможет отправлять его, в том числе в скриптах. Оригинал на платформе и история покупок сохранятся. Восстановление доступно через «Показать скрытые».',
  'media.library.restoreHint': 'Медиа вернётся в библиотеку. Автоматическое использование останется выключенным, пока вы явно не разрешите его в настройках медиа.',
  'media.library.removed': 'Убрано из библиотеки FanLTV. Оригинал на платформе сохранён.',
  'media.library.restored': 'Восстановлено в библиотеке. Автоматическое использование выключено.',
  'media.library.error': 'Не удалось подтвердить изменение библиотеки. Обновите список перед повтором.',
  'media.library.providerMissing': 'Восстановите оригинал на платформе, затем выполните полную синхронизацию.',
  'media.library.removeFromScript': 'Убрать из скрипта',
  'media.library.removeFromScriptHint': 'Убрать только из скрипта. Файл останется в библиотеке.',
  'media.loading': 'Загрузка…',
  'media.loadingError': 'Ошибка загрузки',
  'media.noPreview': 'Нет превью',
  'media.queue': 'В очереди',
  'media.error': 'Ошибка',
  'media.section.photosets': 'Фото и видео',
  'media.section.audio': 'Аудио',
  'media.section.media': 'Медиа',
  'media.sync.stop': 'Остановить',
  'media.sync.stop.title': 'Остановить синхронизацию',
  'media.sync.media': 'Синхронизировать медиа',
  'media.sync.media.needOfApi': 'Подключите OnlyFans API',
  'media.sync.loading': 'Загрузка медиа…',
  'media.downloadAll': 'Загрузить полный контент',
  'media.downloadAll.title': 'Загрузить все медиа',
  'media.downloadAll.confirmTitle': 'Загрузить полный контент всех медиа?',
  'media.downloadAll.confirmMessage': 'Будут загружены только медиа, которые ещё не загружены. Стоимость: ~$1 за каждые 300 MB. Загрузка платная по OnlyFans API.',
  'media.downloadAll.queued': 'В очередь поставлено: {count} медиа',
  'media.downloadQueue.hint': 'Обновляется в реальном времени без перезагрузки',
  'media.downloadQueue.queued': 'В очереди: {count}',
  'media.downloadQueue.downloading': 'Загружается: {count}',
  'media.downloadQueue.downloadingAndQueued': 'Загружается: {downloading}, в очереди: {queued}',
  'media.stats.downloadedOfTotal': 'Загружено: {downloaded} из {total}',
  'media.stats.inQueue': 'В очереди: {count}',
  'media.select.hint': 'Клик по кругу — выбор',
  'media.none': 'Нет медиа',
  'media.selectedCount': 'Выбрано: {count}',
  'media.session.name.placeholder': 'Название фотосессии',
  'media.session.createAndMove': 'Создать фотосессию и переместить',
  'media.session.creating': 'Создание фотосессии…',
  'media.session.none': 'Без привязки к фотосессии',
  'media.session.noneOption': 'Без привязки к фотосессии',
  'media.session.createOption': '➕ Создать фотосессию…',
  'media.move': 'Переместить',
  'media.moving': 'Перемещение…',
  'media.selection.clear': 'Снять выбор',
  'media.session.edit.title': 'Настроить фотосессию',
  'media.session.edit.nameLabel': 'Название',
  'media.session.edit.namePlaceholder': 'Название фотосессии',
  'media.session.edit.descriptionLabel': 'Описание скрипта',
  'media.session.edit.descriptionPlaceholder': 'Когда использовать этот сценарий: настроение, вайб, что видно, кому подходит.',
  'media.session.edit.descriptionHint': 'Используется ботом для выбора подходящего скрипта по контексту диалога. Описания шагов и медиа тоже учитываются.',
  'media.session.edit.tagsLabel': 'Теги выбора',
  'media.session.edit.tagsPlaceholder': 'red dress, garden, feet, soft tease',
  'media.session.edit.tagsHint': 'Через запятую. Пишите словами, которые фан может использовать в запросе.',
  'media.session.edit.timeOfDayLabel': 'Время дня',
  'media.session.edit.timeOfDayPlaceholder': '— не выбрано —',
  'media.session.edit.isScriptLabel': 'Скрипт',
  'media.session.scriptLabel': 'Script',
  'media.session.scriptTooltip': 'Медиа из этой фотосессии продаются последовательно.',
  'media.session.active.ok': 'Фотосессия активна — время дня указано',
  'media.session.active.bad': 'Фотосессия не активна — укажите время дня',
  'media.session.unassignedGroup': 'Без привязки к фотосессии',
  'media.session.unmarkedLabel': 'Не размечено',
  'media.section.unmarked': 'Неразмеченные',
  'media.session.delete.title': 'Удалить фотосессию',
  'media.session.delete.message': 'Удалить фотосессию «{name}»? Медиа перейдут в незабраные.',
  'media.group.add': 'Добавить группу',
  'media.group.addShort': 'Группа',
  'media.group.namePlaceholder': 'Название группы',
  'media.group.unnamed': 'Без названия',
  'media.group.ungrouped': 'Без группы',
  'media.group.edit.title': 'Редактировать группу',
  'media.group.edit.titleUngrouped': 'Цена для «Без группы»',
  'media.group.description': 'Описание шага',
  'media.group.description.placeholder':
    'Опишите шаг целиком: что получает покупатель, угол продажи и важные заметки по использованию.',
  'media.group.price.guideTitle': 'Уровни цены и описания',
  'media.group.price.guideText':
    'Редактирование медиа задаёт описание или цену одного файла. Редактирование группы задаёт описание всего шага и цену этапа.',
  'media.group.price.edit': 'Задать цену и описание шага',
  'media.group.price.editShort': 'Шаг',
  'media.group.price.setShort': 'Цена',
  'media.group.delete.title': 'Удалить группу?',
  'media.group.delete.message': 'Удалить группу «{name}»?\nМедиа останутся в фотосессии.',
  'media.group.reorder': 'Перетащить группу',
  'media.group.readyForSale': 'Группа готова к продаже',
  'media.group.missingForSale': 'Заполните цену группы',
  'media.group.notReadyForSale': 'Группа не готова к продаже',
  'media.reorder.tip': 'Перетащите для изменения порядка',
  'media.timeOfDay.any': 'Любое',
  'media.timeOfDay.morning': 'Утро',
  'media.timeOfDay.day': 'День',
  'media.timeOfDay.evening': 'Вечер',
  'media.timeOfDay.night': 'Ночь',
  'media.category.selfie': 'Селфи',
  'media.category.everyday_photo': 'Everyday фото',
  'media.category.teaser': 'Тизер',
  'media.category.explicit': 'Explicit',
  'media.category.voice_phrase': 'Голосовая фраза',
  'media.excluded.badge': 'Не использовать',
  'media.audio.untitled': 'Аудио без названия',
  'media.audio.source.prerecorded': 'Предзаписанное',
  'media.audio.source.onlyfans': 'OnlyFans',
  'media.audio.voice.short': 'Голос',
  'media.audio.onlyfans.title': 'Аудио из аккаунта',
  'media.audio.onlyfans.empty': 'Синхронизированных аудио из аккаунта пока нет.',
  'media.audio.phrases.title': 'Предзаписанные фразы',
  'media.audio.phrases.empty': 'Предзаписанных фраз пока нет.',
  'media.audio.upload.title': 'Название',
  'media.audio.upload.titlePlaceholder': 'Короткая метка фразы',
  'media.audio.upload.text': 'Текст фразы',
  'media.audio.upload.textPlaceholder': 'Что произносится в аудио',
  'media.audio.voice.label': 'Клонированный голос',
  'media.audio.voice.placeholder': 'voice_id или название голоса у провайдера',
  'media.audio.upload.file': 'Аудиофайл',
  'media.audio.upload.submit': 'Загрузить фразу',
  'media.audio.upload.saved': 'Аудиофраза загружена',
  'media.audio.upload.error': 'Не удалось загрузить аудиофразу',

  // Media edit modal
  'media.edit.modal.title': 'Параметры медиа',
  'media.edit.modal.error': 'Ошибка сохранения',
  'media.edit.isPaidLabel': 'Платное',
  'media.edit.excludedFromAutoUse': 'Не использовать автоматически',
  'media.paid': 'Платное',
  'media.free': 'Бесплатное',
  'media.edit.mediaPrice': 'Цена отдельного медиа ($)',
  'media.edit.mediaPriceHint':
    'Используйте это только если у конкретного файла своя PPV-цена. Цена шага редактируется в группе.',
  'media.edit.price': 'Цена ($)',
  'media.edit.priceRangeAria': 'Диапазон цены',
  'media.edit.priceMinAria': 'Мин. цена ${value}',
  'media.edit.priceMaxAria': 'Макс. цена ${value}',
  'media.edit.description': 'Описание',
  'media.edit.description.placeholder':
    'Опиши что на фото/видео — бот использует это при продаже контента',
  'media.edit.category': 'Категория',
  'media.edit.category.none': 'Без категории',
  'media.edit.hotness': 'Горячесть (1–10)',
  'media.edit.notSelected': 'Не выбрано',
  'media.edit.bodyParts': 'Части тела',
  'media.edit.bodyParts.add': 'Добавить {label}',
  'media.edit.bodyParts.remove': 'Убрать {label}',
  'media.edit.bodyParts.face': 'Лицо',
  'media.edit.bodyParts.chest': 'Грудь',
  'media.edit.bodyParts.butt': 'Попа',
  'media.edit.bodyParts.pussy': 'Киска',
  'media.edit.bodyParts.legs': 'Ноги',

  // Media viewer
  'media.viewer.fileNotUploaded': 'Файл не загружен',
  'media.viewer.loadError': 'Ошибка загрузки',
  'media.viewer.accessError': 'Не удалось получить доступ',
  'media.viewer.imageError': 'Не удалось загрузить изображение',
  'media.viewer.aria.view': 'Просмотр медиа',
  'media.viewer.aria.close': 'Закрыть',
  'media.viewer.loading': 'Загрузка…',

  // Chats
  'chats.title': 'Чаты',
  'chats.tab.real': 'Реальные',
  'chats.tab.test': 'Тест',
  'chats.addTestChat': '+ Тестовый чат',
  'chats.addTestChat.modalTitle': 'Добавить тестовый чат',
  'chats.addTestChat.fanName': 'Имя тестового фана',
  'chats.addTestChat.fanNamePlaceholder': 'test_fan',
  'chats.addTestChat.selectModel': 'Выберите модель',
  'chats.addTestChat.needModel': 'Выберите модель',
  'chats.addTestChat.config': 'Конфигурация',
  'chats.addTestChat.selectConfig': 'Выберите конфигурацию',
  'chats.addTestChat.configActive': 'Активный',
  'chats.addTestChat.active': 'актив.',
  'chats.config.openSettings': 'Настройки конфигурации',
  'chats.editTestChat.title': 'Редактировать тестовый чат',
  'chats.simulate.message': 'Сообщение от фана',
  'chats.simulate.messagePlaceholder': 'Текст сообщения…',
  'chats.simulate.send': 'Отправить',
  'chats.simulate.attachPhoto': 'Прикрепить фото',
  'chats.simulate.attachAudio': 'Прикрепить голосовое',
  'chats.voiceMessage': 'Голосовое сообщение',
  'chats.purchase.buy': 'Купить',
  'chats.purchase.purchased': 'Куплено — медиа из библиотеки',
  'chats.attachments.multiSwipe': 'Прокрутите вбок, чтобы увидеть все файлы в сообщении',
  'chats.attachments.loadMediaTitle': 'Подгрузить медиа в этом сообщении (чат открывается быстрее)',
  'chats.attachments.redactedItem': 'Отправлено: {type} - превью скрыто',
  'chats.attachments.redactedSummary': 'Отправлено медиа модели: {count}. Содержимое скрыто в режиме тестера.',
  'chats.testBadge': 'Тест',
  'chats.modelFilter.placeholder': 'Фильтр по модели',
  'chats.toModel': 'К модели →',
  'chats.loadingModels': 'Загрузка моделей…',
  'chats.loading': 'Загрузка…',
  'chats.sidebar.loading': 'Загрузка…',
  'chats.sidebar.empty':
    'Нет чатов. Сообщения появятся после вебхуков от OnlyFans API.',
  'chats.modelFallback': 'Модель #{id}',
  'chats.noMessages': 'Нет сообщений',
  'chats.typing': 'Модель печатает…',
  'chats.selectLeft': 'Выберите чат слева',
  'chats.thread.loading': 'Загрузка переписки…',
  'chats.error.load': 'Не удалось загрузить чаты',
  'chats.error.microphone': 'Нет доступа к микрофону',
  'chats.error.fileTooLarge': 'Файл слишком большой (максимум 10 МБ)',
  'chats.filter.type': 'Тип',
  'chats.filter.action': 'Действие',
  'chats.filter.model': 'Модель',
  'chats.filter.status': 'Состояние',
  'chats.filter.allModels': '— Все модели —',
  'chats.filter.showBlocked': 'Заблокированные',
  'chats.filter.showAll': 'Все чаты',
  'chats.manual.enable': 'Ручной режим',
  'chats.manual.disable': 'Авто-бот',
  'chats.manual.enable.title': 'Включить ручной режим?',
  'chats.manual.enable.message':
    'Бот перестанет обрабатывать этот чат, пока ручной режим включён. Продолжить?',
  'chats.manual.disable.title': 'Выключить ручной режим?',
  'chats.manual.disable.message':
    'Бот снова начнёт обрабатывать этот чат автоматически. Продолжить?',
  'chats.manualSend.placeholder': 'Написать от имени модели...',
  'chats.manualSend.send': 'Отправить ответ',
  'chats.manualSend.enableHint': 'Включите ручной режим, чтобы отвечать из кабинета.',
  'chats.manualSend.error': 'Не удалось отправить ручной ответ',
  'chats.subscription.active': 'Активная подписка',
  'chats.delete.action': 'Удалить чат',
  'chats.delete.title': 'Удалить чат полностью?',
  'chats.delete.message':
    'Будут удалены сообщения, состояния, графы, логи, аналитика и связанный bot-контекст этого чата. Действие необратимо.',
  'chats.safetyLock.badge': 'Заблокировано системой',
  'chats.safetyLock.unlock': 'Снять блокировку',
  'chats.safetyLock.unlockTitle': 'Снять блокировку чата?',
  'chats.safetyLock.unlockMessage':
    'Автоматическая блокировка будет снята, и бот снова сможет обрабатывать этот чат. Продолжить?',
  'chats.logs.title': 'Логи',
  'chats.logs.messageId': 'message_id: {id}',
  'chats.logs.close': 'Закрыть',
  'chats.logs.loading': 'Загрузка…',
  'chats.logs.empty': 'Логи не найдены',
  'chats.logs.emptyList': 'Нет логов с сообщениями',
  'chats.logs.noPreview': '—',
  'chats.logs.selectHint': 'Выберите лог в списке или кликните на исходящее сообщение',
  'chats.logs.error': 'Не удалось загрузить лог',
  'chats.logs.incomingOnly': 'Логи доступны только для исходящих сообщений бота',
  'chats.logs.openHint': 'Открыть логи сообщения',
  'chats.logs.incomingHint': 'Для входящих сообщений лог графа отсутствует',
  'chats.logs.graph': 'Граф',
  'chats.logs.nodes': 'Узлы',
  'chats.logs.aiCalls': 'AI-вызовы',
  'chats.logs.parameters': 'Изменения параметров',
  'chats.logs.paramsBefore': 'До',
  'chats.logs.paramsAfter': 'После',
  'chats.logs.paramsChanges': 'Изменения',
  'chats.logs.paramsL3': 'L3 (счётчики)',
  'chats.logs.paramsL4': 'L4 (сценарий)',
  'chats.logs.paramsNoChanges': 'На этом шаге изменений нет',
  'chats.logs.copyConditionPreview': 'Копировать плоский JSON для предпросмотра условий',
  'chats.logs.monetizationSummaryTitle': 'Итог ядра (constraints)',
  'chats.logs.monetizationSummaryAllowOffer': 'allow_offer',
  'chats.logs.monetizationSummaryAllowChatMedia': 'allow_chat_media',
  'chats.logs.conditionPreviewSource.core_snapshot': 'JSON для превью условий: точный снимок Core (контекст run_monetization / emit_chat_media).',
  'chats.logs.conditionPreviewSource.legacy_merged_after': 'JSON для превью: приблизительно (L3/L4 after + current_state); у новых графов будет точный снимок.',
  'chats.logs.rawParameterJson': 'Детали параметров',
  'chats.logs.agents': 'Агенты и узлы',
  'chats.logs.noAgents': 'Нет данных',
  'chats.logs.nodeLabel.in': 'Входящее сообщение',
  'chats.logs.nodeLabel.core': 'Ядро',
  'chats.logs.nodeLabel.core_brain': 'Ядро',
  'chats.logs.nodeLabel.media_selector': 'Media Selector',
  'chats.logs.nodeLabel.send': 'Отправка',
  'chats.logs.nodeLabel.policy_safety_action': 'Действие модератора',
  'chats.logs.nodeLabel.parallel_analyzer_memory': 'Анализатор + Memory Summary',
  'chats.logs.status': 'Статус',
  'chats.logs.input': 'Вход',
  'chats.logs.output': 'Выход',
  'chats.logs.request': 'Запрос',
  'chats.logs.response': 'Ответ',
  'chats.logs.duration': 'Время',
  'chats.logs.durationWithDelay': 'Время с задержкой',
  'chats.logs.delaySeconds': 'задержка {n} с',
  'chats.logs.stateTransition': 'Состояние',
  'chats.logs.rawData': 'Сырые данные графа',
  'chats.logs.safetyLockBanner': 'Ответ заблокирован (SAFETY_LOCK)',
  'chats.logs.safetyLockReason': 'Причина: {reason}',
  'chats.logs.failedReason': 'Причина сбоя:',
  'chats.logs.safetyLockHint': 'Анализатор вернул risk_flag → граф завершён без отправки сообщения.',

  // Analytics
  'analytics.title': 'Аналитика',
  'analytics.loading': 'Загрузка аналитики…',
  'analytics.empty': 'Снапшоты не найдены',
  'analytics.recompute.action': 'Пересчитать',
  'analytics.recompute.running': 'Пересчёт…',
  'analytics.scope.label': 'Scope',
  'analytics.scope.all': 'Все scope',
  'analytics.scope.global': 'Global',
  'analytics.scope.model': 'Model',
  'analytics.scope.fanModel': 'Fan+Model',
  'analytics.snapshot.label': 'Тип снапшота',
  'analytics.snapshot.all': 'Все типы',
  'analytics.snapshot.fanStates': 'Fan states',
  'analytics.snapshot.revenue': 'Revenue',
  'analytics.snapshot.performance': 'Bot performance',
  'analytics.snapshot.openaiCost': 'OpenAI cost',
  'analytics.snapshot.fanProfile': 'Fan profile',
  'analytics.model.label': 'Модель',
  'analytics.model.all': '— Выберите модель —',
  'analytics.fanModel.placeholder': 'scope_id fan_model, например: 12:3',
  'analytics.table.computedAt': 'Вычислено',
  'analytics.table.scope': 'Scope',
  'analytics.table.type': 'Тип',
  'analytics.table.period': 'Период',
  'analytics.table.data': 'Данные',
  'analytics.table.open': 'Открыть детали',

  // Fans / purchases table (ModelDataPage)
  'modelData.fans.title': 'Фаны',
  'modelData.fans.model': 'Модель',
  'modelData.fans.name': 'Имя',
  'modelData.fans.username': 'Username',
  'modelData.fans.id': 'ID',
  'modelData.fans.test': 'Тест',
  'modelData.fans.createdAt': 'Создан',
  'modelData.chats.title': 'Чаты',
  'modelData.chats.direction': 'Направление',
  'modelData.chats.fan': 'Фан',
  'modelData.chats.messageId': 'ID сообщения',
  'modelData.chats.createdAt': 'Создано',
  'modelData.chats.incoming': '← Входящее',
  'modelData.chats.outgoing': '→ Исходящее',
  'modelData.purchases.title': 'Покупки',
  'modelData.purchases.model': 'Модель',
  'modelData.purchases.fan': 'Фан',
  'modelData.purchases.type': 'Тип',
  'modelData.purchases.amount': 'Сумма',
  'modelData.purchases.createdAt': 'Создано',
  'modelData.filterByModel': 'Фильтр по модели',
  'modelData.toModel': 'К модели →',
  'modelData.loadingModels': 'Загрузка моделей…',
  'modelData.loading': 'Загрузка…',
  'modelData.allModels': '— Все модели —',
  'modelData.allTypes': 'Все (тест+реал)',
  'modelData.selectModel': 'Выберите модель',
  'modelData.total': 'Всего: {count}',
  'modelData.noData': 'Нет данных',

  // Error boundary
  'errorBoundary.title': 'Что-то пошло не так',
  'errorBoundary.unknown': 'Неизвестная ошибка',
  'errorBoundary.retry': 'Попробовать снова',

  // Generic API errors (fallbacks)
  'errors.model.create': 'Не удалось создать модель',
  'errors.profile.load': 'Не удалось загрузить профиль',
  'errors.account.load': 'Не удалось загрузить данные аккаунта',
  'errors.account.update': 'Не удалось обновить описание аккаунта',
  'errors.reconnect.start': 'Не удалось запустить переподключение',
  'errors.connect.start': 'Не удалось запустить подключение',
  'errors.connect.cancel': 'Не удалось отменить подключение',
  'errors.media.load': 'Не удалось загрузить медиа',
  'errors.media.update': 'Не удалось обновить медиа',
  'errors.media.sync.start': 'Не удалось запустить синхронизацию',
  'errors.media.sync.stop': 'Не удалось остановить синхронизацию',
  'errors.media.downloadAll': 'Не удалось поставить загрузку',
  'errors.media.token': 'Не удалось получить токен',
  'errors.session.create': 'Не удалось создать фотосессию',
  'errors.session.move': 'Не удалось переместить',
  'errors.session.generic': 'Не удалось создать сессию',
  'errors.generic.save': 'Не удалось сохранить',
  'errors.media.download': 'Ошибка загрузки медиа',
  'errors.media.sync': 'Ошибка синхронизации',
  'errors.media.stoppedByUser': 'Остановлено пользователем',
  'errors.access': 'Не удалось получить доступ',
  'errors.sessionExpired': 'Сессия истекла',
  'errors.request': 'Ошибка запроса',

  // Logs page (bot execution logs)
  'logs.title': 'Логи запусков графа',
  'logs.subtitle': 'Логи каждого запущенного графа — от входящего сообщения или проактивного follow-up',
  'logs.modelFilter': 'Модель',
  'logs.statusFilter': 'Статус',
  'logs.status.all': 'Все',
  'logs.status.COMPLETED': 'Завершён',
  'logs.status.FAILED': 'Ошибка',
  'logs.status.ROLLBACK': 'Откат',
  'logs.status.RUNNING': 'Выполняется',
  'logs.status.WAITING_LLM': 'Ожидание LLM',
  'logs.status.PENDING': 'В очереди',
  'logs.loading': 'Загрузка логов…',
  'logs.empty': 'Логов не найдено',
  'logs.error': 'Не удалось загрузить логи',
  'logs.selectLeft': 'Выберите лог из списка',
  'logs.initiatedBy': 'Инициатор',
  'logs.initiatedBy.fan': 'Сообщение фана',
  'logs.initiatedBy.system': 'Система',
  'logs.detailTitle': 'Детали лога',
  'logs.graphId': 'ID графа',
  'logs.back': 'Назад',

  // Logs sub-nav
  'logs.nav.graphs': 'Графы',
  'logs.nav.proactive': 'Проактивный бот',

  // Proactive logs page
  'logs.proactive.title': 'Логи запусков проактивного бота',
  'logs.proactive.subtitle': 'История запусков follow-up по молчанию. «С запусками агента» — только те, где был запуск агента.',
  'logs.proactive.runsCount': 'Запусков: {count}',
  'logs.proactive.graphsCount': 'Графов: {count}',
  'logs.proactive.agentRunsCount': 'Запусков агента: {count}',
  'logs.proactive.agentRunsOfRun': 'Запуски агента ({count})',
  'logs.proactive.noAgentRunsInRun': 'Нет запусков',
  'logs.proactive.selectAgentRunHint': 'Выберите запуск, затем — запуск агента по фану.',
  'logs.proactive.selectAgentRunFromList': 'Выберите запуск агента из списка слева',
  'logs.proactive.backToAgentRuns': 'К списку',
  'logs.proactive.agentRun': 'Запуск агента',
  'logs.proactive.empty': 'Нет запусков',
  'logs.proactive.toGraphLogs': '→ К логам графов',
  'logs.proactive.runsList': 'Запуски',
  'logs.proactive.selectRun': 'Выберите запуск',
  'logs.proactive.graphsOfRun': 'Графы запуска ({count})',
  'logs.proactive.noGraphsInRun': 'Графы не найдены',
  'logs.proactive.selectRunHint': 'Выберите запуск слева',
  'logs.proactive.selectGraphHint': 'Затем выберите граф для просмотра лога',
  'logs.proactive.selectGraphFromList': 'Выберите граф из списка слева',
  'logs.proactive.backToGraphs': 'К графам',
  'logs.proactive.openInGraphLogs': 'Открыть в логах графов',
  'logs.proactive.trigger.silence_followup': 'Follow-up по молчанию',
  'logs.proactive.trigger.unknown': 'Система',
  'logs.proactive.filter.label': 'Запуски',
  'logs.proactive.filter.all': 'Все',
  'logs.proactive.filter.withAgentRuns': 'С запусками агента',
  'logs.proactive.pagination.range': '{from}–{to} из {total}',
  'logs.proactive.pagination.page': 'Страница {n}',

  // Restored classic / agency settings keys
  'layout.nav.agencySettings': 'Настройки агентства',
  'login.remember': 'Запомнить меня',
  'login.titleUnified': 'Вход',
  'common.copied': 'Скопировано',
  'common.refresh': 'Обновить',
  'chats.export.chatHistory': 'Экспорт истории чата',
  'chats.loadEarlier': 'Загрузить раньше',
  'chats.logs.copyLog': 'Скопировать лог',
  'chats.simulate.recordAudio': 'Записать аудио',
  'chats.simulate.stopRecording': 'Остановить запись',
  'chats.simulate.uploading': 'Загрузка...',
  'media.session.reorder': 'Изменить порядок',
  'settings.config.activateBlocked': 'Исправьте ошибки валидации перед активацией конфигурации.',
  'settings.variables.deleteConditionGroupMessage': 'Удалить эту группу условий?',
  'modelDetail.account.automation.fullAuto': 'Полный автомат',
  'modelDetail.account.automation.handoffOnOffer': 'Передача на оффере',
  'modelDetail.account.automation.handoffAfterFirstPurchase': 'Передача после первой покупки',
  'modelDetail.account.telegram.tokenHint': 'Вставьте новый токен только если нужно заменить сохранённый.',
  'users.billing.plan.monthly_flat': 'Фикс в месяц',
  'users.billing.plan.per_bot_message': 'За сообщение бота',
  'users.billing.plan.revenue_share': 'Доля выручки',
  'users.billing.plan.hybrid': 'Гибрид',
  'users.billing.plan.custom': 'Индивидуальный',

  'agencySettings.title': 'Настройки агентства',
  'agencySettings.hint': 'Управление моделями, безопасными настройками графа, проактивными правилами и реактивацией истории.',
  'agencySettings.tabs.label': 'Раздел',
  'agencySettings.tabs.models': 'Модели',
  'agencySettings.tabs.l4': 'L4 переменные',
  'agencySettings.tabs.proactive': 'Проактив',
  'agencySettings.tabs.timewasters': 'Таймвестеры',
  'agencySettings.tabs.customPricing': 'Цены кастомов',
  'agencySettings.tabs.monetizationRoutes': 'Маршруты монетизации',
  'agencySettings.tabs.prompt': 'Промпты',
  'agencySettings.tabs.reactivation': 'Реактивация',
  'agencySettings.tabs.transitions': 'Переходы',
  'agencySettings.tabs.conditionalPrompts': 'Условные промпты',
  'agencySettings.tabs.engineApi': 'Engine API',
  'agencySettings.tabs.mcp': 'Настройка MCP',
  'agencySettings.tabs.onboarding': 'Онбординг',
  'agencySettings.onboarding.title': 'Пошаговая настройка модели',
  'agencySettings.onboarding.hint': 'Подключите аккаунты, добавьте анкету, проверьте предложения ИИ и прошлые чаты, настройте голос и продукты, затем протестируйте точную версию.',
  'agencySettings.onboarding.safety': 'Доступны только назначенные вам модели. Черновик не меняет живые ответы, а публикация не снимает паузу с бота.',
  'agencySettings.onboarding.open': 'Начать или продолжить онбординг',
  'agencySettings.engineApi.title': 'FanLTV Engine API',
  'agencySettings.engineApi.hint': 'Подключайте внешнюю платформу без сведения FanLTV к endpoint последнего сообщения. Контекст синхронизируется постоянно, а решение запрашивается только когда FanLTV должен действовать.',
  'agencySettings.engineApi.clientName': 'Название интеграции',
  'agencySettings.engineApi.callbackUrl': 'Callback URL (необязательно)',
  'agencySettings.engineApi.defaultMode': 'Режим по умолчанию',
  'agencySettings.engineApi.create': 'Создать API-клиент',
  'agencySettings.engineApi.revoke': 'Отозвать',
  'agencySettings.engineApi.empty': 'API-клиенты ещё не созданы.',
  'agencySettings.engineApi.credentialsOnce': 'Сохраните credentials сейчас. Повторно они не показываются.',
  'agencySettings.engineApi.created': 'API-клиент создан',
  'agencySettings.engineApi.revoked': 'API-клиент отозван',

  'agencySettings.billing.plan': 'План',
  'agencySettings.billing.balance': 'Баланс',
  'agencySettings.billing.lowBalanceThreshold': 'Порог низкого баланса',
  'agencySettings.billing.rate': 'Тариф',
  'agencySettings.billing.sent30d': 'Отправлено за 30 дней',
  'agencySettings.billing.messages30d': 'Списано за 30 дней',
  'agencySettings.billing.amount30d': 'Сумма за 30 дней',
  'agencySettings.billing.available': 'Доступно сообщений',

  'agencySettings.models.settingsTitle': 'Рабочие настройки моделей',
  'agencySettings.models.settingsHint': 'Профиль, таймзона, режим автоматизации и уведомления операторов по каждой модели.',
  'agencySettings.models.model': 'Модель',
  'agencySettings.models.connection': 'Подключение',
  'agencySettings.models.description': 'Описание профиля',
  'agencySettings.models.descriptionHint': 'Персона, тон, границы, стиль продаж и контекст аккаунта.',
  'agencySettings.models.descriptionPlaceholder': 'Опишите голос модели, ограничения и стиль продаж.',
  'agencySettings.models.timezone': 'Таймзона',
  'agencySettings.models.timezoneHint': 'Используется для проактивных сообщений и тихих часов.',
  'agencySettings.models.timezonePlaceholder': 'Europe/Moscow',
  'agencySettings.models.automation': 'Автоматизация',
  'agencySettings.models.automationMode': 'Режим автоматизации',
  'agencySettings.models.automationModeHint': 'Определяет, что бот может делать без подтверждения оператора.',
  'agencySettings.models.defaultConfig': 'Конфиг модели по умолчанию',
  'agencySettings.models.defaultConfigHint': 'Используется для новых диалогов, если у чата не задан отдельный конфиг.',
  'agencySettings.models.defaultConfigActive': 'Использовать активный глобальный конфиг',
  'agencySettings.models.defaultConfigActiveBadge': 'активный',
  'agencySettings.models.botStatus': 'Статус бота',
  'agencySettings.models.botPaused': 'На паузе',
  'agencySettings.models.botActive': 'Активен',
  'agencySettings.models.pauseBot': 'Поставить на паузу',
  'agencySettings.models.resumeBot': 'Возобновить бота',
  'agencySettings.models.profileReady': 'Профиль готов',
  'agencySettings.models.profileMissing': 'Профиль не заполнен',
  'agencySettings.models.telegram': 'Telegram уведомления',
  'agencySettings.models.telegramEnabled': 'Включить Telegram уведомления',
  'agencySettings.models.telegramEnabledHint': 'Отправлять рабочие события во внешний Telegram чат.',
  'agencySettings.models.telegramChatId': 'Telegram chat ID',
  'agencySettings.models.telegramChatIdHint': 'ID чата, группы или канала для уведомлений.',
  'agencySettings.models.telegramChatIdPlaceholder': '-100...',
  'agencySettings.models.telegramToken': 'Telegram bot token',
  'agencySettings.models.telegramTokenPlaceholder': 'Вставьте токен для установки или замены',
  'agencySettings.models.telegramTokenSet': 'Токен сохранён',
  'agencySettings.models.telegramEvents': 'События уведомлений',
  'agencySettings.models.telegramSetupTitle': 'Настройка Telegram',
  'agencySettings.models.telegramSetupStep1': 'Создайте бота через BotFather.',
  'agencySettings.models.telegramSetupStep2': 'Добавьте его в операторский чат.',
  'agencySettings.models.telegramSetupStep3': 'Вставьте токен и chat ID здесь.',
  'agencySettings.models.save': 'Сохранить настройки модели',
  'agencySettings.models.saved': 'Настройки модели сохранены',
  'agencySettings.models.saveError': 'Не удалось сохранить настройки модели',
  'agencySettings.models.enabled': 'Включено',
  'agencySettings.models.disabled': 'Выключено',
  'agencySettings.models.empty': 'Нет доступных моделей.',
  'agencySettings.models.event.state_changed': 'Состояние изменилось',
  'agencySettings.models.event.low_balance': 'Низкий баланс',
  'agencySettings.models.event.handoff_on_offer': 'Передача на оффере',
  'agencySettings.models.event.handoff_after_first_purchase': 'Передача после первой покупки',
  'agencySettings.models.event.purchase': 'Подтверждённые покупки',
  'agencySettings.models.event.insufficient_credit': 'Недостаточно кредита',
  'agencySettings.models.event.graph_failed': 'Ошибка графа',
  'agencySettings.models.event.openai_timeout': 'Таймаут OpenAI',

  'agencySettings.config.copy': 'Копия конфигурации',
  'agencySettings.config.copyHint': 'Изменения агентства сохраняются в выбранную безопасную копию конфигурации.',
  'agencySettings.config.copyActive': 'Скопировать активный конфиг',
  'agencySettings.config.copied': 'Копия конфигурации создана',
  'agencySettings.config.copyError': 'Не удалось скопировать конфигурацию',
  'agencySettings.config.saved': 'Конфигурация сохранена',
  'agencySettings.config.saveError': 'Не удалось сохранить конфигурацию',
  'agencySettings.config.transitions': 'Переходы графа',
  'agencySettings.config.transitionsHint': 'Безопасные условия переходов, доступные операторам агентства.',
  'agencySettings.l4.title': 'L4 переменные',
  'agencySettings.l4.hint': 'Бизнес-переменные для условий переходов и проактивных правил.',
  'agencySettings.proactive.rulesTitle': 'Правила follow-up',
  'agencySettings.proactive.rulesHint': 'Первое подходящее правило определяет, когда можно отправить проактивное сообщение.',
  'agencySettings.proactive.cadenceTitle': 'Настройки частоты',
  'agencySettings.proactive.webhooksTitle': 'События провайдера',
  'agencySettings.promptControls.title': 'Настройки промптов',
  'agencySettings.customPricing.title': 'Ценообразование кастомного контента',
  'agencySettings.customCapabilities.title': 'Возможности производства кастомов',
  'agencySettings.customCapabilities.modelScopeTitle': 'Сначала выберите модель',
  'agencySettings.customCapabilities.modelScopeHint': 'Возможности и цены кастомов хранятся в graph config, назначенном выбранной модели.',
  'agencySettings.customCapabilities.modelLabel': 'Модель, чьи настройки кастомов вы редактируете',
  'agencySettings.customCapabilities.editingModel': 'Редактируется модель',
  'agencySettings.customCapabilities.assignedConfig': 'Назначенный graph config',
  'agencySettings.customCapabilities.globalConfigWarning': 'Модель использует активный общий config. Сохранение также изменит все модели, использующие общий config.',
  'agencySettings.customCapabilities.sharedConfigWarning': 'Этот graph config назначен нескольким моделям. Сохранение изменит настройки кастомов у всех них.',
  'agencySettings.customCapabilities.exclusiveConfig': 'Этот graph config назначен только выбранной модели.',
  'agencySettings.customCapabilities.changeAssignmentHint': 'Чтобы изменить назначение, откройте раздел «Модели» и выберите Default graph config для этой модели.',
  'agencySettings.customCapabilities.group.availability': 'Доступность и сроки',
  'agencySettings.customCapabilities.group.boundaries': 'Нюд и явные границы',
  'agencySettings.customCapabilities.group.partners': 'Парный контент',
  'agencySettings.customCapabilities.group.production': 'Гардероб, покупки и реквизит',
  'agencySettings.customCapabilities.group.scenarios': 'Границы сценариев',
  'agencySettings.customCapabilities.nudity.clothed': 'В одежде / без нюд',
  'agencySettings.customCapabilities.nudity.lingerie': 'Бельё',
  'agencySettings.customCapabilities.nudity.topless': 'Топлес',
  'agencySettings.customCapabilities.nudity.full_nude': 'Полный нюд',
  'agencySettings.customCapabilities.nudity.explicit_closeup': 'Откровенный крупный план',
  'agencySettings.customCapabilities.prop.lingerie': 'Бельё',
  'agencySettings.customCapabilities.prop.stockings': 'Чулки',
  'agencySettings.customCapabilities.prop.high_heels': 'Туфли на каблуке',
  'agencySettings.customCapabilities.prop.costume': 'Костюм / косплей',
  'agencySettings.customCapabilities.prop.mask': 'Маска',
  'agencySettings.customCapabilities.prop.blindfold': 'Повязка на глаза',
  'agencySettings.customCapabilities.prop.restraints': 'Фиксаторы',
  'agencySettings.customCapabilities.prop.vibrator': 'Вибратор',
  'agencySettings.customCapabilities.prop.dildo': 'Дилдо',
  'agencySettings.customCapabilities.prop.butt_plug': 'Анальная пробка',
  'agencySettings.customCapabilities.prop.body_oil': 'Масло для тела',
  'agencySettings.customCapabilities.prop.candles': 'Свечи',
  'agencySettings.customPricing.previewTitle': 'Предварительный расчёт',
  'agencySettings.customPricing.previewHint': 'Нижняя цена защищена; бот начинает с верхней и может торговаться только до нижней границы.',
  'agencySettings.customPricing.previewError': 'Не удалось рассчитать цену',
  'agencySettings.customPricing.contentType': 'Тип контента',
  'agencySettings.customPricing.photoCount': 'Количество фото',
  'agencySettings.customPricing.duration': 'Длительность, минут',
  'agencySettings.customPricing.urgency': 'Срок выполнения',
  'agencySettings.customPricing.actualExpenses': 'Подтверждённые расходы',
  'agencySettings.customPricing.includeName': 'Персонализация по имени',
  'agencySettings.customPricing.externalItems': 'Нужно купить реквизит или одежду',
  'agencySettings.customPricing.calculate': 'Рассчитать',
  'agencySettings.customPricing.floor': 'Минимальная цена продажи',
  'agencySettings.customPricing.opening': 'Начальная цена',
  'agencySettings.customPricing.deposit': 'Депозит чаевыми от начальной цены',
  'agencySettings.customPricing.externalPending': 'Итоговая цена будет известна после подтверждения фактической стоимости реквизита или одежды.',

  'agencySettings.monetizationRoutes.eyebrow': 'Продажи',
  'agencySettings.monetizationRoutes.title': 'Маршруты монетизации',
  'agencySettings.monetizationRoutes.description': 'Дополнительные маршруты продаж включаются отдельно и по умолчанию отключены для каждого конфига.',
  'agencySettings.monetizationRoutes.navDescription': 'Физические товары, одобренные запросы поддержки и адаптация стиля по согласию.',
  'agencySettings.monetizationRoutes.save': 'Сохранить маршруты монетизации',
  'agencySettings.monetizationRoutes.value': 'Значение',
  'agencySettings.monetizationRoutes.enabled': 'Включено',
  'agencySettings.monetizationRoutes.disabled': 'Отключено',
  'agencySettings.monetizationRoutes.badge.manualReview': 'Ручная проверка',
  'agencySettings.monetizationRoutes.badge.modelApproved': 'Одобрено моделью',
  'agencySettings.monetizationRoutes.badge.explicitSignal': 'Явный сигнал',
  'agencySettings.monetizationRoutes.physical.title': 'Продажа физических товаров',
  'agencySettings.monetizationRoutes.physical.description': 'Каждый заказ требует ручной проверки наличия, правил платформы и доставки до подтверждения цены или выполнения.',
  'agencySettings.monetizationRoutes.support.title': 'Запросы поддержки и подарков',
  'agencySettings.monetizationRoutes.support.description': 'Причина должна быть правдивой, актуальной и одобренной моделью. Нельзя придумывать экстренную ситуацию, долги или давить на фана.',
  'agencySettings.monetizationRoutes.interaction.title': 'Адаптивный стиль общения и ролей',
  'agencySettings.monetizationRoutes.interaction.description': 'Обычная манера общения меняется только при высокой уверенности. Доминантная или восприимчивая роль требует явной просьбы и согласия фана.',

  'agencySettings.reactivation.settingsTitle': 'Настройки реактивации истории',
  'agencySettings.reactivation.queueTitle': 'Очередь реактивации',
  'agencySettings.reactivation.queueHint': 'Проверяйте кандидатов, найденных в старых диалогах.',
  'agencySettings.reactivation.status': 'Статус',
  'agencySettings.reactivation.allStatuses': 'Все статусы',
  'agencySettings.reactivation.runTick': 'Запустить поиск',
  'agencySettings.reactivation.dispatchApproved': 'Отправить одобренные',
  'agencySettings.reactivation.fan': 'Фан',
  'agencySettings.reactivation.queueStatus': 'Статус очереди',
  'agencySettings.reactivation.source': 'Источник',
  'agencySettings.reactivation.lastMessage': 'Последнее сообщение',
  'agencySettings.reactivation.decision': 'Решение',
  'agencySettings.reactivation.approve': 'Одобрить',
  'agencySettings.reactivation.skip': 'Пропустить',
  'agencySettings.reactivation.empty': 'В очереди нет элементов.',
  'agencySettings.reactivation.total': 'Всего: {count}',
  'agencySettings.reactivation.queued': 'Действие реактивации поставлено в очередь',

  'agencySettings.transitions.add': 'Добавить переход',
  'agencySettings.transitions.empty': 'Переходы не настроены.',
  'agencySettings.transitions.key': 'Ключ перехода',
  'agencySettings.transitions.keyPlaceholder': 'transition_key',
  'agencySettings.transitions.emptyKey': 'Ключ перехода обязателен.',
  'agencySettings.transitions.duplicateKey': 'Дублирующийся ключ перехода: {key}',

  'agencySettings.conditionalPrompts.title': 'Условные промпты',
  'agencySettings.conditionalPrompts.hint': 'Дополнительный текст промпта применяется только при совпадении условия.',
  'agencySettings.conditionalPrompts.agent.message_generator': 'Генератор сообщений',
  'agencySettings.conditionalPrompts.agent.photo_generator': 'Генератор ответа на входящее медиа',
  'agencySettings.conditionalPrompts.agent.offer_generator': 'Генератор офферов',
  'agencySettings.conditionalPrompts.agent.proactive_message_generator': 'Генератор проактивных сообщений',
  'agencySettings.conditionalPrompts.empty': 'Нет правил условных промптов.',
  'agencySettings.conditionalPrompts.addRule': 'Добавить правило',
  'agencySettings.conditionalPrompts.role': 'Роль',
  'agencySettings.conditionalPrompts.order': 'Порядок',
  'agencySettings.conditionalPrompts.enabled': 'Включено',
  'agencySettings.conditionalPrompts.prompt': 'Промпт',

  'agencySettings.timewasters.title': 'Работа с таймвестерами',

  'agencySettings.setting.proactive_message_generator_conversation_messages_count': 'Сообщений контекста для проактива',
  'agencySettings.setting.proactive_followup_max_dispatch_per_tick': 'Максимум отправок за тик',
  'agencySettings.setting.proactive_skip_test_fans': 'Пропускать тестовых фанов',
  'agencySettings.setting.proactive_cannot_send_retry_minutes': 'Повтор после cannot-send, минут',
  'agencySettings.setting.proactive_daily_touch_max_hours': 'Окно daily touch, часов',
  'agencySettings.setting.proactive_recent_continuation_max_days': 'Дней для продолжения свежего чата',
  'agencySettings.setting.proactive_warm_reactivation_max_days': 'Дней для тёплой реактивации',
  'agencySettings.setting.proactive_webhook_users_online_enabled': 'Событие online',
  'agencySettings.setting.proactive_webhook_users_typing_enabled': 'Событие typing',
  'agencySettings.setting.proactive_webhook_posts_liked_enabled': 'Событие post liked',
  'agencySettings.setting.proactive_webhook_posts_commented_enabled': 'Событие post commented',
  'agencySettings.setting.proactive_webhook_min_silence_minutes': 'Минимальная тишина, минут',
  'agencySettings.setting.proactive_webhook_cooldown_minutes': 'Cooldown webhook, минут',
  'agencySettings.setting.proactive_webhook_custom_events': 'Дополнительные webhook события',
  'agencySettings.setting.history_reactivation_enabled': 'Реактивация истории включена',
  'agencySettings.setting.history_reactivation_dry_run': 'Dry run',
  'agencySettings.setting.history_reactivation_batch_size': 'Размер батча',
  'agencySettings.setting.history_reactivation_scan_max_pages': 'Максимум страниц скана',
  'agencySettings.setting.history_reactivation_include_active_free': 'Включать активных free',
  'agencySettings.setting.history_reactivation_include_free_with_history': 'Включать free с историей',
  'agencySettings.setting.history_reactivation_free_auto_approve': 'Автоодобрение free',
  'agencySettings.setting.history_reactivation_auto_dispatch_enabled': 'Автоотправка',
  'agencySettings.setting.history_reactivation_auto_dispatch_limit': 'Лимит автоотправки',
  'agencySettings.setting.history_reactivation_messages_limit': 'Сообщений для импорта',
  'agencySettings.setting.history_reactivation_min_silence_hours': 'Минимальная тишина, часов',
  'agencySettings.setting.history_reactivation_max_age_days': 'Максимальный возраст, дней',
  'agencySettings.setting.history_reactivation_dispatch_limit': 'Лимит отправки',
  'agencySettings.setting.history_reactivation_max_attempts': 'Максимум попыток',
  'agencySettings.setting.history_reactivation_retry_minutes': 'Повтор через, минут',
  'agencySettings.setting.prompt_language_match_fan': 'Отвечать на языке фана',
  'agencySettings.setting.prompt_primary_language': 'Основной язык',
  'agencySettings.setting.prompt_allowed_languages': 'Разрешённые языки',
  'agencySettings.setting.prompt_tone_style': 'Стиль тона',
  'agencySettings.setting.prompt_emoji_level': 'Уровень emoji',
  'agencySettings.setting.prompt_message_length': 'Длина сообщения',
  'agencySettings.setting.prompt_disallowed_topics': 'Запрещённые темы',
  'agencySettings.setting.prompt_custom_safe_instructions': 'Безопасные инструкции',
  'agencySettings.setting.timewaster_strategy_enabled': 'Включить работу с таймвестерами',
  'agencySettings.setting.timewaster_min_fan_messages': 'Порог сообщений от фана',
  'agencySettings.setting.timewaster_high_tension_min': 'Минимальный высокий tension',
  'agencySettings.setting.timewaster_low_spend_intent_max': 'Максимальный низкий spend intent',
  'agencySettings.setting.timewaster_reply_delay_min_seconds': 'Минимальная задержка ответа, секунд',
  'agencySettings.setting.timewaster_reply_delay_max_seconds': 'Максимальная задержка ответа, секунд',
  'agencySettings.setting.custom_requests_enabled': 'Разрешить кастомы',
  'agencySettings.setting.custom_capabilities_configured': 'Применять настроенные возможности',
  'agencySettings.setting.custom_photo_enabled': 'Разрешить кастомные фото',
  'agencySettings.setting.custom_video_enabled': 'Разрешить кастомные видео',
  'agencySettings.setting.custom_audio_enabled': 'Разрешить кастомные audio / voice',
  'agencySettings.setting.personalized_audio_fantasy_enabled': 'Совместная фантазия в голосовой кастом',
  'agencySettings.setting.personalized_audio_fantasy_min_words': 'Минимум слов в развитой фантазии',
  'agencySettings.setting.personalized_audio_fantasy_soft_offer_after_signals': 'Сигналов до предложения audio',
  'agencySettings.setting.custom_name_personalization_enabled': 'Разрешить персонализацию именем',
  'agencySettings.setting.custom_face_allowed': 'Можно показывать лицо',
  'agencySettings.setting.custom_external_items_allowed': 'Можно покупать новые props/outfits',
  'agencySettings.setting.custom_outfit_purchase_allowed': 'Можно купить одежду под заказ',
  'agencySettings.setting.custom_prop_purchase_allowed': 'Можно купить реквизит под заказ',
  'agencySettings.setting.custom_max_purchase_budget': 'Максимальный бюджет покупки',
  'agencySettings.setting.custom_max_nudity_level': 'Максимальная степень нюд',
  'agencySettings.setting.custom_toy_use_allowed': 'Можно использовать игрушки',
  'agencySettings.setting.custom_toy_insertion_allowed': 'Можно вставлять игрушки',
  'agencySettings.setting.custom_other_object_insertion_allowed': 'Можно вставлять другие предметы',
  'agencySettings.setting.custom_gg_content_allowed': 'Парный контент GG',
  'agencySettings.setting.custom_bg_content_allowed': 'Парный контент BG',
  'agencySettings.setting.custom_max_photo_count': 'Максимум фото в кастоме',
  'agencySettings.setting.custom_max_video_minutes': 'Максимум минут видео',
  'agencySettings.setting.custom_max_audio_minutes': 'Максимум минут audio',
  'agencySettings.setting.custom_standard_turnaround_days': 'Стандартный срок, дней',
  'agencySettings.setting.custom_allowed_scenarios': 'Разрешённые идеи сценариев',
  'agencySettings.setting.custom_forbidden_scenarios': 'Запрещённые сценарии',
  'agencySettings.setting.custom_available_outfits': 'Доступные outfits',
  'agencySettings.setting.custom_available_locations': 'Доступные locations',
  'agencySettings.setting.custom_available_prop_categories': 'Доступный реквизит',
  'agencySettings.setting.custom_available_props': 'Другой доступный реквизит',
  'agencySettings.setting.custom_pricing_enabled': 'Автоматический расчёт кастомов',
  'agencySettings.setting.custom_pricing_currency': 'Валюта',
  'agencySettings.setting.custom_pricing_base_fee': 'Базовая стоимость производства',
  'agencySettings.setting.custom_pricing_minimum_total': 'Минимальная сумма заказа',
  'agencySettings.setting.custom_pricing_video_per_minute': 'Цена минуты видео',
  'agencySettings.setting.custom_pricing_audio_per_minute': 'Цена минуты аудио',
  'agencySettings.setting.custom_pricing_photo_each': 'Цена одного фото',
  'agencySettings.setting.custom_pricing_name_markup_percent': 'Наценка за имя, %',
  'agencySettings.setting.custom_pricing_urgency_72h_percent': 'Наценка за срочность до 72 часов, %',
  'agencySettings.setting.custom_pricing_urgency_24h_percent': 'Наценка за срочность до 24 часов, %',
  'agencySettings.setting.custom_pricing_negotiation_margin_percent': 'Запас для торга, %',
  'agencySettings.setting.custom_pricing_minimum_deposit_percent': 'Минимальный депозит чаевыми, %',
  'agencySettings.setting.physical_item_sales_enabled': 'Продажа физических товаров',
  'agencySettings.setting.physical_item_currency': 'Валюта физических товаров',
  'agencySettings.setting.physical_item_underwear_starting_price': 'Начальная цена белья',
  'agencySettings.setting.physical_item_clothing_starting_price': 'Начальная цена одежды',
  'agencySettings.setting.physical_item_other_starting_price': 'Начальная цена других товаров',
  'agencySettings.setting.physical_item_worn_day_markup': 'Наценка за день носки',
  'agencySettings.setting.physical_item_personalization_markup': 'Наценка за персонализацию',
  'agencySettings.setting.support_route_enabled': 'Маршрут поддержки и подарков',
  'agencySettings.setting.support_afterglow_enabled': 'Мягкая просьба после сцены',
  'agencySettings.setting.support_afterglow_min_score': 'Минимальная уверенность afterglow',
  'agencySettings.setting.support_afterglow_cooldown_days': 'Пауза между просьбами, дней',
  'agencySettings.setting.support_chat_gate_enabled': 'Лимит бесплатного roleplay',
  'agencySettings.setting.support_chat_gate_message_limit': 'Сообщений до мягкого gate',
  'agencySettings.setting.support_chat_gate_min_tip_amount': 'Минимальные чаевые для продолжения',
  'agencySettings.setting.support_chat_gate_currency': 'Валюта chat gate',
  'agencySettings.setting.support_chat_gate_cooldown_days': 'Пауза между gate, дней',
  'agencySettings.setting.support_wishlist_enabled': 'Проверенный wishlist',
  'agencySettings.setting.support_wishlist_url': 'Ссылка на wishlist',
  'agencySettings.setting.support_wishlist_profile_linked': 'Ссылка размещена в профиле/bio',
  'agencySettings.setting.support_campaign_enabled': 'Активная кампания поддержки',
  'agencySettings.setting.support_campaign_reason': 'Причина кампании',
  'agencySettings.setting.support_campaign_goal_amount': 'Цель кампании',
  'agencySettings.setting.support_campaign_currency': 'Валюта кампании',
  'agencySettings.setting.support_campaign_cooldown_days': 'Пауза для одного фана, дней',
  'agencySettings.setting.adaptive_dominant_style_enabled': 'Адаптивный доминантный стиль',
  'agencySettings.setting.adaptive_dominant_style_min_score': 'Минимальный балл явного сигнала',
  'agencySettings.setting.adaptive_receptive_style_enabled': 'Разрешить восприимчивую роль модели',
  'agencySettings.setting.adaptive_power_style_max_intensity': 'Максимальная интенсивность роли',
  'agencySettings.setting.adaptive_interaction_style_enabled': 'Адаптивная манера общения',
  'agencySettings.setting.adaptive_interaction_style_min_confidence': 'Минимальная уверенность в стиле общения',

  'agencySettings.settingDesc.proactive_message_generator_conversation_messages_count': 'Сколько последних сообщений передавать в контекст проактивной генерации.',
  'agencySettings.settingDesc.proactive_followup_max_dispatch_per_tick': 'Максимум проактивных сообщений за один проход планировщика.',
  'agencySettings.settingDesc.proactive_skip_test_fans': 'Не отправлять проактивные сообщения в тестовые чаты.',
  'agencySettings.settingDesc.proactive_cannot_send_retry_minutes': 'Пауза перед повтором после provider cannot-send.',
  'agencySettings.settingDesc.proactive_daily_touch_max_hours': 'Верхняя граница окна daily touch.',
  'agencySettings.settingDesc.proactive_recent_continuation_max_days': 'Как долго свежий чат доступен для продолжения.',
  'agencySettings.settingDesc.proactive_warm_reactivation_max_days': 'Как долго тёплые фаны доступны для реактивации.',
  'agencySettings.settingDesc.proactive_webhook_users_online_enabled': 'Реагировать на событие users-online.',
  'agencySettings.settingDesc.proactive_webhook_users_typing_enabled': 'Реагировать на событие users-typing.',
  'agencySettings.settingDesc.proactive_webhook_posts_liked_enabled': 'Реагировать на лайки постов.',
  'agencySettings.settingDesc.proactive_webhook_posts_commented_enabled': 'Реагировать на комментарии к постам.',
  'agencySettings.settingDesc.proactive_webhook_min_silence_minutes': 'Минимальная тишина перед webhook-driven сообщением.',
  'agencySettings.settingDesc.proactive_webhook_cooldown_minutes': 'Cooldown после webhook-driven сообщения.',
  'agencySettings.settingDesc.proactive_webhook_custom_events': 'Дополнительные события провайдера через запятую.',
  'agencySettings.settingDesc.history_reactivation_enabled': 'Разрешает старым диалогам попадать в workflow реактивации.',
  'agencySettings.settingDesc.history_reactivation_dry_run': 'Находит кандидатов без отправки сообщений.',
  'agencySettings.settingDesc.history_reactivation_batch_size': 'Сколько диалогов сканировать за батч.',
  'agencySettings.settingDesc.history_reactivation_scan_max_pages': 'Максимум страниц провайдера за запуск.',
  'agencySettings.settingDesc.history_reactivation_include_active_free': 'Включать активных free-фанов в поиск.',
  'agencySettings.settingDesc.history_reactivation_include_free_with_history': 'Включать free-фанов с прошлой историей чата.',
  'agencySettings.settingDesc.history_reactivation_free_auto_approve': 'Автоматически одобрять free-кандидатов.',
  'agencySettings.settingDesc.history_reactivation_auto_dispatch_enabled': 'Разрешает автоматически отправлять одобренным кандидатам.',
  'agencySettings.settingDesc.history_reactivation_auto_dispatch_limit': 'Максимум автоотправок за запуск.',
  'agencySettings.settingDesc.history_reactivation_messages_limit': 'Сколько старых сообщений импортировать для контекста.',
  'agencySettings.settingDesc.history_reactivation_min_silence_hours': 'Минимальная тишина до попадания фана в кандидаты.',
  'agencySettings.settingDesc.history_reactivation_max_age_days': 'Самые старые диалоги, доступные для реактивации.',
  'agencySettings.settingDesc.history_reactivation_dispatch_limit': 'Лимит ручной отправки за запуск.',
  'agencySettings.settingDesc.history_reactivation_max_attempts': 'Количество повторов для неудачных кандидатов.',
  'agencySettings.settingDesc.history_reactivation_retry_minutes': 'Пауза между повторами реактивации.',
  'agencySettings.settingDesc.prompt_language_match_fan': 'Если включено, бот сохраняет язык фана.',
  'agencySettings.settingDesc.prompt_primary_language': 'Язык по умолчанию, если язык фана неизвестен.',
  'agencySettings.settingDesc.prompt_allowed_languages': 'Список языков через запятую, которые бот может использовать.',
  'agencySettings.settingDesc.prompt_tone_style': 'Стиль общения по умолчанию для генерации сообщений.',
  'agencySettings.settingDesc.prompt_emoji_level': 'Как часто бот использует выразительные маркеры.',
  'agencySettings.settingDesc.prompt_message_length': 'Предпочтительная длина ответа.',
  'agencySettings.settingDesc.prompt_disallowed_topics': 'Темы через запятую, которых бот должен избегать.',
  'agencySettings.settingDesc.prompt_custom_safe_instructions': 'Guardrails агентства, добавляемые к безопасным промптам.',
  'agencySettings.settingDesc.timewaster_strategy_enabled': 'Опциональная стратегия для длинных диалогов без подтверждённой оплаты, с высоким tension и низким spend intent.',
  'agencySettings.settingDesc.timewaster_min_fan_messages': 'Минимальное количество входящих сообщений фана до возможного включения стратегии.',
  'agencySettings.settingDesc.timewaster_high_tension_min': 'Минимальный sexual tension score для игривой границы ценности.',
  'agencySettings.settingDesc.timewaster_low_spend_intent_max': 'Максимальный spend intent score, который ещё считается низким намерением купить.',
  'agencySettings.settingDesc.timewaster_reply_delay_min_seconds': 'Нижняя граница случайной задержки ответа при активной стратегии.',
  'agencySettings.settingDesc.timewaster_reply_delay_max_seconds': 'Верхняя граница случайной задержки ответа при активной стратегии.',
  'agencySettings.settingDesc.custom_requests_enabled': 'Включает для этого конфига маршрут заказных фото, видео и аудио.',
  'agencySettings.settingDesc.custom_capabilities_configured': 'Делает форматы, лимиты и границы ниже обязательными для маршрута и расчёта цены. Сначала заполните всю матрицу.',
  'agencySettings.settingDesc.custom_photo_enabled': 'Модель действительно может снимать заказные фотосеты.',
  'agencySettings.settingDesc.custom_video_enabled': 'Модель действительно может снимать заказные видео.',
  'agencySettings.settingDesc.custom_audio_enabled': 'Модель действительно может записывать заказные audio или voice notes.',
  'agencySettings.settingDesc.personalized_audio_fantasy_enabled': 'Позволяет сначала развить фантазию вместе с фаном, а затем один раз мягко предложить персональную историю голосом.',
  'agencySettings.settingDesc.personalized_audio_fantasy_min_words': 'Минимальная длина сообщения, когда развитую фантазию определяет контекст, а не прямое слово fantasy.',
  'agencySettings.settingDesc.personalized_audio_fantasy_soft_offer_after_signals': 'Сколько вкладов фана в фантазию требуется до одного мягкого предложения персонального audio.',
  'agencySettings.settingDesc.custom_name_personalization_enabled': 'Разрешает произносить, писать или иначе использовать имя фана.',
  'agencySettings.settingDesc.custom_face_allowed': 'Разрешает показывать лицо модели в заказном контенте.',
  'agencySettings.settingDesc.custom_external_items_allowed': 'Разрешает заказы, для которых нужно купить или найти новый предмет, outfit или prop.',
  'agencySettings.settingDesc.custom_outfit_purchase_allowed': 'Разрешает купить одежду специально для заказа и добавить подтверждённую стоимость к цене.',
  'agencySettings.settingDesc.custom_prop_purchase_allowed': 'Разрешает купить недостающий реквизит специально для кастома.',
  'agencySettings.settingDesc.custom_max_purchase_budget': 'Жёсткий лимит расходов; ноль означает ручное согласование без заданного лимита.',
  'agencySettings.settingDesc.custom_max_nudity_level': 'Самый откровенный визуальный уровень, одобренный моделью.',
  'agencySettings.settingDesc.custom_toy_use_allowed': 'Разрешает показывать или использовать игрушки.',
  'agencySettings.settingDesc.custom_toy_insertion_allowed': 'Отдельно разрешает вставлять игрушки; требует включённого использования игрушек.',
  'agencySettings.settingDesc.custom_other_object_insertion_allowed': 'Разрешает вставлять одобренные предметы, не относящиеся к игрушкам.',
  'agencySettings.settingDesc.custom_gg_content_allowed': 'Разрешает заказной контент девушка–девушка с другой исполнительницей.',
  'agencySettings.settingDesc.custom_bg_content_allowed': 'Разрешает заказной контент девушка–парень с другим исполнителем.',
  'agencySettings.settingDesc.custom_max_photo_count': 'Жёсткий максимум количества фото до предложения цены.',
  'agencySettings.settingDesc.custom_max_video_minutes': 'Жёсткий максимум длительности одного заказного видео.',
  'agencySettings.settingDesc.custom_max_audio_minutes': 'Жёсткий максимум длительности одного заказного audio.',
  'agencySettings.settingDesc.custom_standard_turnaround_days': 'Обычное производственное окно; бот не должен обещать его как гарантированный дедлайн.',
  'agencySettings.settingDesc.custom_allowed_scenarios': 'Одобренные моделью темы через запятую. Пустое поле не создаёт выдуманный whitelist.',
  'agencySettings.settingDesc.custom_forbidden_scenarios': 'Жёсткие границы через запятую; совпавший запрос блокируется до цены.',
  'agencySettings.settingDesc.custom_available_outfits': 'Только реально доступные модели outfits, которые бот может упоминать.',
  'agencySettings.settingDesc.custom_available_locations': 'Только безопасные реально доступные locations без приватных адресов.',
  'agencySettings.settingDesc.custom_available_prop_categories': 'Стандартный реквизит, который уже есть и не требует покупки.',
  'agencySettings.settingDesc.custom_available_props': 'Дополнительный реквизит, которого нет в списке с галочками.',
  'agencySettings.settingDesc.custom_pricing_enabled': 'Разрешает боту рассчитывать цену кастома и торговаться по этим правилам.',
  'agencySettings.settingDesc.custom_pricing_currency': 'Валюта цены кастома и подтверждённого депозита чаевыми.',
  'agencySettings.settingDesc.custom_pricing_base_fee': 'Фиксированная сумма, добавляемая до ставки за минуту или фото.',
  'agencySettings.settingDesc.custom_pricing_minimum_total': 'Абсолютная нижняя граница, ниже которой бот не может опускать цену.',
  'agencySettings.settingDesc.custom_pricing_video_per_minute': 'Базовая ставка, умножаемая на длительность видео.',
  'agencySettings.settingDesc.custom_pricing_audio_per_minute': 'Базовая ставка, умножаемая на длительность аудио.',
  'agencySettings.settingDesc.custom_pricing_photo_each': 'Базовая ставка, умножаемая на количество фотографий.',
  'agencySettings.settingDesc.custom_pricing_name_markup_percent': 'Процент за произнесение, написание или другую персонализацию имени фана.',
  'agencySettings.settingDesc.custom_pricing_urgency_72h_percent': 'Процент за выполнение заказа в течение 72 часов.',
  'agencySettings.settingDesc.custom_pricing_urgency_24h_percent': 'Процент за выполнение в течение 24 часов; не может быть ниже наценки за 72 часа.',
  'agencySettings.settingDesc.custom_pricing_negotiation_margin_percent': 'Наценка над защищённым минимумом, с которой бот начинает торг.',
  'agencySettings.settingDesc.custom_pricing_minimum_deposit_percent': 'Доля согласованной цены, которая должна прийти подтверждёнными чаевыми до начала производства; минимум 50%.',
  'agencySettings.settingDesc.physical_item_sales_enabled': 'Разрешает обсуждать физические товары; наличие и доставка всегда подтверждаются оператором вручную.',
  'agencySettings.settingDesc.physical_item_currency': 'Валюта начальных цен и наценок для физических товаров.',
  'agencySettings.settingDesc.physical_item_underwear_starting_price': 'Начальная цена белья до проверки срока носки, персонализации и доставки.',
  'agencySettings.settingDesc.physical_item_clothing_starting_price': 'Начальная цена одежды до проверки персонализации и доставки.',
  'agencySettings.settingDesc.physical_item_other_starting_price': 'Начальная цена других разрешённых товаров до ручной проверки.',
  'agencySettings.settingDesc.physical_item_worn_day_markup': 'Сумма за каждый запрошенный день носки; наличие должна подтвердить модель или оператор.',
  'agencySettings.settingDesc.physical_item_personalization_markup': 'Сумма за записку, имя или другой одобренный вариант персонализации.',
  'agencySettings.settingDesc.support_route_enabled': 'Разрешает настроенный маршрут поддержки и подарков, но не выдуманные причины или неутверждённые способы оплаты.',
  'agencySettings.settingDesc.support_afterglow_enabled': 'Разрешает один необязательный намёк на чаевые после подтверждённого успешного завершения длительной согласованной сцены. Посреди сцены маршрут не срабатывает.',
  'agencySettings.settingDesc.support_afterglow_min_score': 'Минимальная уверенность анализатора от 50 до 100 для запуска маршрута после сцены.',
  'agencySettings.settingDesc.support_afterglow_cooldown_days': 'Минимальная пауза для одного фана перед следующей мягкой просьбой о чаевых.',
  'agencySettings.settingDesc.support_chat_gate_enabled': 'Приостанавливает активную откровенную сцену после лимита бесплатных сообщений и один раз игриво предлагает оставить чаевые на кофе. Обычный разговор остаётся доступным.',
  'agencySettings.settingDesc.support_chat_gate_message_limit': 'Количество сообщений фана после последнего коммерческого предложения, после которого активная откровенная сцена может попасть под мягкий gate.',
  'agencySettings.settingDesc.support_chat_gate_min_tip_amount': 'Одна подтверждённая транзакция должна быть не меньше этой суммы, чтобы продолжить откровенный roleplay. Меньшие чаевые не снимают gate.',
  'agencySettings.settingDesc.support_chat_gate_currency': 'Валюта минимальных подтверждённых чаевых.',
  'agencySettings.settingDesc.support_chat_gate_cooldown_days': 'Минимальная пауза для одного фана перед повторным запросом после лимита roleplay.',
  'agencySettings.settingDesc.support_wishlist_enabled': 'Разрешает боту упоминать указанный и одобренный моделью wishlist. Подарок остаётся добровольным и не является оплатой контента или доступа.',
  'agencySettings.settingDesc.support_wishlist_url': 'Точная публичная HTTPS-ссылка, одобренная моделью. Бот не может придумывать или подменять её.',
  'agencySettings.settingDesc.support_wishlist_profile_linked': 'Подтверждает, что wishlist уже размещён в профиле/bio модели; без этого Fansly-маршрут не будет направлять туда фанов.',
  'agencySettings.settingDesc.support_campaign_enabled': 'Активирует текущую одобренную моделью кампанию только при заполненной правдивой причине.',
  'agencySettings.settingDesc.support_campaign_reason': 'Правдивая актуальная причина, одобренная моделью, например «чёрный комплект белья, который уже есть в моём wishlist». Бот может называть только записанные здесь детали. Оставьте пустой, если активной кампании нет.',
  'agencySettings.settingDesc.support_campaign_goal_amount': 'Необязательная прозрачная цель кампании; ноль означает, что конкретной суммы нет.',
  'agencySettings.settingDesc.support_campaign_currency': 'Валюта цели кампании.',
  'agencySettings.settingDesc.support_campaign_cooldown_days': 'Минимальная пауза перед повторным запросом поддержки у того же фана.',
  'agencySettings.settingDesc.adaptive_dominant_style_enabled': 'Разрешает доминантный тон только после явного предпочтения или просьбы фана, а не по слабому предположению.',
  'agencySettings.settingDesc.adaptive_dominant_style_min_score': 'Порог явного сигнала от 50 до 100; отзыв согласия всегда прекращает стиль независимо от балла.',
  'agencySettings.settingDesc.adaptive_receptive_style_enabled': 'Разрешает модели игриво принимать ведущую роль фана только после его явной просьбы. Границы модели и ручная проверка сохраняются.',
  'agencySettings.settingDesc.adaptive_power_style_max_intensity': 'Ограничивает выраженность согласованного доминантного или восприимчивого тона от 1 до 5 и не меняет safety или оплату.',
  'agencySettings.settingDesc.adaptive_interaction_style_enabled': 'Адаптирует прямоту, теплоту, игривость, детализацию и темп по уверенным сигналам диалога, но не определяет сексуальное согласие.',
  'agencySettings.settingDesc.adaptive_interaction_style_min_confidence': 'Минимальная уверенность анализатора от 50 до 100, после которой стиль сохраняется для фана.',
}
